/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicSignUpIndexRouteImport } from './routes/_public/sign-up/index'
import { Route as PublicSignInIndexRouteImport } from './routes/_public/sign-in/index'
import { Route as PublicSignUpSplatRouteImport } from './routes/_public/sign-up/$'
import { Route as PublicSignInSplatRouteImport } from './routes/_public/sign-in/$'
import { Route as AuthStaffInviteTokenRouteImport } from './routes/_auth/staff-invite/$token'
import { Route as AuthAppSelectOrganizationRouteImport } from './routes/_auth/app/select-organization'
import { Route as AuthAppAppRouteImport } from './routes/_auth/app/_app'
import { Route as AuthAppAppIndexRouteImport } from './routes/_auth/app/_app/index'
import { Route as AuthAppAppHelpRouteImport } from './routes/_auth/app/_app/help'
import { Route as AuthAppAppUserSettingsIndexRouteImport } from './routes/_auth/app/_app/user-settings/index'
import { Route as AuthAppAppHelpIndexRouteImport } from './routes/_auth/app/_app/help/index'
import { Route as AuthAppAppOrgRenewPlatformPlanRouteImport } from './routes/_auth/app/_app/org/renew-platform-plan'
import { Route as AuthAppAppOrgOrgIdRouteImport } from './routes/_auth/app/_app/org/$orgId'
import { Route as AuthAppAppHelpUserGuideRouteImport } from './routes/_auth/app/_app/help/user-guide'
import { Route as AuthAppAppHelpSupportRouteImport } from './routes/_auth/app/_app/help/support'
import { Route as AuthAppAppOrgOrgIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/index'
import { Route as AuthAppAppHelpUserGuideIndexRouteImport } from './routes/_auth/app/_app/help/user-guide/index'
import { Route as AuthAppAppHelpSupportIndexRouteImport } from './routes/_auth/app/_app/help/support/index'
import { Route as AuthAppAppOrgOrgIdUnder_developmentRouteImport } from './routes/_auth/app/_app/org/$orgId/under_development'
import { Route as AuthAppAppOrgOrgIdOnboardingRouteImport } from './routes/_auth/app/_app/org/$orgId/onboarding'
import { Route as AuthAppAppOrgOrgIdEquipmentRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment'
import { Route as AuthAppAppOrgOrgIdAssistantRouteImport } from './routes/_auth/app/_app/org/$orgId/assistant'
import { Route as AuthAppAppHelpUserGuidePlanningRouteImport } from './routes/_auth/app/_app/help/user-guide/planning'
import { Route as AuthAppAppHelpUserGuideMarketplaceRouteImport } from './routes/_auth/app/_app/help/user-guide/marketplace'
import { Route as AuthAppAppHelpUserGuideLivestockRouteImport } from './routes/_auth/app/_app/help/user-guide/livestock'
import { Route as AuthAppAppHelpUserGuideGrassProductionRouteImport } from './routes/_auth/app/_app/help/user-guide/grass-production'
import { Route as AuthAppAppHelpUserGuideFinancialRouteImport } from './routes/_auth/app/_app/help/user-guide/financial'
import { Route as AuthAppAppHelpUserGuideFeasibilityRouteImport } from './routes/_auth/app/_app/help/user-guide/feasibility'
import { Route as AuthAppAppHelpUserGuideEstablishmentsRouteImport } from './routes/_auth/app/_app/help/user-guide/establishments'
import { Route as AuthAppAppHelpUserGuideEquipmentRouteImport } from './routes/_auth/app/_app/help/user-guide/equipment'
import { Route as AuthAppAppHelpUserGuideAssistantRouteImport } from './routes/_auth/app/_app/help/user-guide/assistant'
import { Route as AuthAppAppOrgOrgIdStaffRouteRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/route'
import { Route as AuthAppAppOrgOrgIdSettingsRouteRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/route'
import { Route as AuthAppAppOrgOrgIdMarketplaceRouteRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/route'
import { Route as AuthAppAppOrgOrgIdFinancialRouteRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/route'
import { Route as AuthAppAppOrgOrgIdFeasibilityRouteRouteImport } from './routes/_auth/app/_app/org/$orgId/feasibility/route'
import { Route as AuthAppAppOrgOrgIdStaffIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/index'
import { Route as AuthAppAppOrgOrgIdSettingsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/index'
import { Route as AuthAppAppOrgOrgIdPlanningIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/index'
import { Route as AuthAppAppOrgOrgIdPendingActionsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/pending-actions/index'
import { Route as AuthAppAppOrgOrgIdOfflineCenterIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/offline-center/index'
import { Route as AuthAppAppOrgOrgIdMcpIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/mcp/index'
import { Route as AuthAppAppOrgOrgIdMarketplaceIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/index'
import { Route as AuthAppAppOrgOrgIdLivestockIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/index'
import { Route as AuthAppAppOrgOrgIdGrassProductionIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/index'
import { Route as AuthAppAppOrgOrgIdFinancialIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/index'
import { Route as AuthAppAppOrgOrgIdFeasibilityIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/feasibility/index'
import { Route as AuthAppAppOrgOrgIdEstablishmentsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/establishments/index'
import { Route as AuthAppAppOrgOrgIdEquipmentIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/index'
import { Route as AuthAppAppOrgOrgIdAssistantIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/assistant/index'
import { Route as AuthAppAppHelpSupportTicketsIndexRouteImport } from './routes/_auth/app/_app/help/support/tickets/index'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId'
import { Route as AuthAppAppOrgOrgIdMarketplaceOfferIdRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/$offerId'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId'
import { Route as AuthAppAppOrgOrgIdFeasibilityNewRouteImport } from './routes/_auth/app/_app/org/$orgId/feasibility/new'
import { Route as AuthAppAppOrgOrgIdAssistantConversationIdRouteImport } from './routes/_auth/app/_app/org/$orgId/assistant/$conversationId'
import { Route as AuthAppAppHelpSupportTicketsTicketIdRouteImport } from './routes/_auth/app/_app/help/support/tickets/$ticketId'
import { Route as AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/platform-plan/index'
import { Route as AuthAppAppOrgOrgIdSettingsLivestockIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/livestock/index'
import { Route as AuthAppAppOrgOrgIdSettingsFinancialIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/financial/index'
import { Route as AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/establishments/index'
import { Route as AuthAppAppOrgOrgIdSettingsAiKeysIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/ai-keys/index'
import { Route as AuthAppAppOrgOrgIdPlanningTasksIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/tasks/index'
import { Route as AuthAppAppOrgOrgIdPlanningObjectivesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/objectives/index'
import { Route as AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/my-requests/index'
import { Route as AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/my-offers/index'
import { Route as AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/incoming-requests/index'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/index'
import { Route as AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/cultivars/index'
import { Route as AuthAppAppOrgOrgIdFinancialVendorsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/vendors/index'
import { Route as AuthAppAppOrgOrgIdFinancialTransactionsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/transactions/index'
import { Route as AuthAppAppOrgOrgIdFinancialReportsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/reports/index'
import { Route as AuthAppAppOrgOrgIdFinancialRecurringIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/recurring/index'
import { Route as AuthAppAppOrgOrgIdFinancialReceivablesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/receivables/index'
import { Route as AuthAppAppOrgOrgIdFinancialPayrollIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payroll/index'
import { Route as AuthAppAppOrgOrgIdFinancialPayablesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payables/index'
import { Route as AuthAppAppOrgOrgIdFinancialLoansIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/loans/index'
import { Route as AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/feasibility/$studyId/index'
import { Route as AuthAppAppOrgOrgIdEquipmentScheduleIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/schedule/index'
import { Route as AuthAppAppOrgOrgIdEquipmentPartsIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/parts/index'
import { Route as AuthAppAppOrgOrgIdEquipmentFleetIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/fleet/index'
import { Route as AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/breakdown-report/index'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdPermissionsRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/permissions'
import { Route as AuthAppAppOrgOrgIdStaffStaffIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/staff/$staffId/edit'
import { Route as AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/platform-plan/update'
import { Route as AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRouteImport } from './routes/_auth/app/_app/org/$orgId/settings/platform-plan/success'
import { Route as AuthAppAppOrgOrgIdPlanningTasksKanbanRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/tasks/kanban'
import { Route as AuthAppAppOrgOrgIdPlanningTasksCalendarRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/tasks/calendar'
import { Route as AuthAppAppOrgOrgIdMarketplaceMyOffersNewRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/my-offers/new'
import { Route as AuthAppAppOrgOrgIdGrassProductionCultivarsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/cultivars/new'
import { Route as AuthAppAppOrgOrgIdFinancialTransactionsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/transactions/new'
import { Route as AuthAppAppOrgOrgIdFinancialTransactionsImportRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/transactions/import'
import { Route as AuthAppAppOrgOrgIdFinancialRecurringNewRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/recurring/new'
import { Route as AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/receivables/$receivableId'
import { Route as AuthAppAppOrgOrgIdFinancialPayablesNewRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payables/new'
import { Route as AuthAppAppOrgOrgIdFinancialPayablesBillIdRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payables/$billId'
import { Route as AuthAppAppOrgOrgIdFinancialLoansNewRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/loans/new'
import { Route as AuthAppAppOrgOrgIdEquipmentPartsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/parts/new'
import { Route as AuthAppAppOrgOrgIdEquipmentFleetNewRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/fleet/new'
import { Route as AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/breakdown-report/$reportId'
import { Route as AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/tasks/$taskId/index'
import { Route as AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/planning/objectives/$objectiveId/index'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/weighing/index'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/registries/index'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/index'
import { Route as AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/transactions/$transactionId/index'
import { Route as AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/recurring/$templateId/index'
import { Route as AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payroll/workers/index'
import { Route as AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payroll/labor/index'
import { Route as AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/loans/$loanId/index'
import { Route as AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/parts/$partId/index'
import { Route as AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/index'
import { Route as AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/marketplace/my-offers/$offerId.edit'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/new'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/new'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/import'
import { Route as AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/cultivars/$cultivarId/edit'
import { Route as AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/parts/$partId/edit'
import { Route as AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/inspect'
import { Route as AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/edit'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/index'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/index'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/index'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/map/index'
import { Route as AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/financial/payroll/runs/$runId/index'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/soil-reports/import'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/new'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/index'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new'
import { Route as AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
import { Route as AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRouteImport } from './routes/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/index'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpIndexRoute = PublicSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInIndexRoute = PublicSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpSplatRoute = PublicSignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInSplatRoute = PublicSignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => PublicRoute,
} as any)
const AuthStaffInviteTokenRoute = AuthStaffInviteTokenRouteImport.update({
  id: '/staff-invite/$token',
  path: '/staff-invite/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppSelectOrganizationRoute =
  AuthAppSelectOrganizationRouteImport.update({
    id: '/app/select-organization',
    path: '/app/select-organization',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAppAppRoute = AuthAppAppRouteImport.update({
  id: '/app/_app',
  path: '/app',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppAppIndexRoute = AuthAppAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppHelpRoute = AuthAppAppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppUserSettingsIndexRoute =
  AuthAppAppUserSettingsIndexRouteImport.update({
    id: '/user-settings/',
    path: '/user-settings/',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppHelpIndexRoute = AuthAppAppHelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppHelpRoute,
} as any)
const AuthAppAppOrgRenewPlatformPlanRoute =
  AuthAppAppOrgRenewPlatformPlanRouteImport.update({
    id: '/org/renew-platform-plan',
    path: '/org/renew-platform-plan',
    getParentRoute: () => AuthAppAppRoute,
  } as any)
const AuthAppAppOrgOrgIdRoute = AuthAppAppOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AuthAppAppRoute,
} as any)
const AuthAppAppHelpUserGuideRoute = AuthAppAppHelpUserGuideRouteImport.update({
  id: '/user-guide',
  path: '/user-guide',
  getParentRoute: () => AuthAppAppHelpRoute,
} as any)
const AuthAppAppHelpSupportRoute = AuthAppAppHelpSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthAppAppHelpRoute,
} as any)
const AuthAppAppOrgOrgIdIndexRoute = AuthAppAppOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppAppOrgOrgIdRoute,
} as any)
const AuthAppAppHelpUserGuideIndexRoute =
  AuthAppAppHelpUserGuideIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpSupportIndexRoute =
  AuthAppAppHelpSupportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppHelpSupportRoute,
  } as any)
const AuthAppAppOrgOrgIdUnder_developmentRoute =
  AuthAppAppOrgOrgIdUnder_developmentRouteImport.update({
    id: '/under_development',
    path: '/under_development',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOnboardingRoute =
  AuthAppAppOrgOrgIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentRoute =
  AuthAppAppOrgOrgIdEquipmentRouteImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdAssistantRoute =
  AuthAppAppOrgOrgIdAssistantRouteImport.update({
    id: '/assistant',
    path: '/assistant',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppHelpUserGuidePlanningRoute =
  AuthAppAppHelpUserGuidePlanningRouteImport.update({
    id: '/planning',
    path: '/planning',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideMarketplaceRoute =
  AuthAppAppHelpUserGuideMarketplaceRouteImport.update({
    id: '/marketplace',
    path: '/marketplace',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideLivestockRoute =
  AuthAppAppHelpUserGuideLivestockRouteImport.update({
    id: '/livestock',
    path: '/livestock',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideGrassProductionRoute =
  AuthAppAppHelpUserGuideGrassProductionRouteImport.update({
    id: '/grass-production',
    path: '/grass-production',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideFinancialRoute =
  AuthAppAppHelpUserGuideFinancialRouteImport.update({
    id: '/financial',
    path: '/financial',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideFeasibilityRoute =
  AuthAppAppHelpUserGuideFeasibilityRouteImport.update({
    id: '/feasibility',
    path: '/feasibility',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideEstablishmentsRoute =
  AuthAppAppHelpUserGuideEstablishmentsRouteImport.update({
    id: '/establishments',
    path: '/establishments',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideEquipmentRoute =
  AuthAppAppHelpUserGuideEquipmentRouteImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppHelpUserGuideAssistantRoute =
  AuthAppAppHelpUserGuideAssistantRouteImport.update({
    id: '/assistant',
    path: '/assistant',
    getParentRoute: () => AuthAppAppHelpUserGuideRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffRouteRoute =
  AuthAppAppOrgOrgIdStaffRouteRouteImport.update({
    id: '/staff',
    path: '/staff',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsRouteRoute =
  AuthAppAppOrgOrgIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceRouteRoute =
  AuthAppAppOrgOrgIdMarketplaceRouteRouteImport.update({
    id: '/marketplace',
    path: '/marketplace',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialRouteRoute =
  AuthAppAppOrgOrgIdFinancialRouteRouteImport.update({
    id: '/financial',
    path: '/financial',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFeasibilityRouteRoute =
  AuthAppAppOrgOrgIdFeasibilityRouteRouteImport.update({
    id: '/feasibility',
    path: '/feasibility',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffIndexRoute =
  AuthAppAppOrgOrgIdStaffIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsIndexRoute =
  AuthAppAppOrgOrgIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningIndexRoute =
  AuthAppAppOrgOrgIdPlanningIndexRouteImport.update({
    id: '/planning/',
    path: '/planning/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdPendingActionsIndexRoute =
  AuthAppAppOrgOrgIdPendingActionsIndexRouteImport.update({
    id: '/pending-actions/',
    path: '/pending-actions/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdOfflineCenterIndexRoute =
  AuthAppAppOrgOrgIdOfflineCenterIndexRouteImport.update({
    id: '/offline-center/',
    path: '/offline-center/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdMcpIndexRoute =
  AuthAppAppOrgOrgIdMcpIndexRouteImport.update({
    id: '/mcp/',
    path: '/mcp/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceIndexRoute =
  AuthAppAppOrgOrgIdMarketplaceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockIndexRoute =
  AuthAppAppOrgOrgIdLivestockIndexRouteImport.update({
    id: '/livestock/',
    path: '/livestock/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionIndexRouteImport.update({
    id: '/grass-production/',
    path: '/grass-production/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialIndexRoute =
  AuthAppAppOrgOrgIdFinancialIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFeasibilityIndexRoute =
  AuthAppAppOrgOrgIdFeasibilityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdFeasibilityRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdEstablishmentsIndexRoute =
  AuthAppAppOrgOrgIdEstablishmentsIndexRouteImport.update({
    id: '/establishments/',
    path: '/establishments/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentIndexRoute =
  AuthAppAppOrgOrgIdEquipmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdAssistantIndexRoute =
  AuthAppAppOrgOrgIdAssistantIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdAssistantRoute,
  } as any)
const AuthAppAppHelpSupportTicketsIndexRoute =
  AuthAppAppHelpSupportTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AuthAppAppHelpSupportRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdRoute =
  AuthAppAppOrgOrgIdStaffStaffIdRouteImport.update({
    id: '/$staffId',
    path: '/$staffId',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceOfferIdRoute =
  AuthAppAppOrgOrgIdMarketplaceOfferIdRouteImport.update({
    id: '/$offerId',
    path: '/$offerId',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteImport.update({
    id: '/livestock/$establishmentId',
    path: '/livestock/$establishmentId',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFeasibilityNewRoute =
  AuthAppAppOrgOrgIdFeasibilityNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthAppAppOrgOrgIdFeasibilityRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdAssistantConversationIdRoute =
  AuthAppAppOrgOrgIdAssistantConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AuthAppAppOrgOrgIdAssistantRoute,
  } as any)
const AuthAppAppHelpSupportTicketsTicketIdRoute =
  AuthAppAppHelpSupportTicketsTicketIdRouteImport.update({
    id: '/tickets/$ticketId',
    path: '/tickets/$ticketId',
    getParentRoute: () => AuthAppAppHelpSupportRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute =
  AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRouteImport.update({
    id: '/platform-plan/',
    path: '/platform-plan/',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsLivestockIndexRoute =
  AuthAppAppOrgOrgIdSettingsLivestockIndexRouteImport.update({
    id: '/livestock/',
    path: '/livestock/',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsFinancialIndexRoute =
  AuthAppAppOrgOrgIdSettingsFinancialIndexRouteImport.update({
    id: '/financial/',
    path: '/financial/',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute =
  AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRouteImport.update({
    id: '/establishments/',
    path: '/establishments/',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute =
  AuthAppAppOrgOrgIdSettingsAiKeysIndexRouteImport.update({
    id: '/ai-keys/',
    path: '/ai-keys/',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningTasksIndexRoute =
  AuthAppAppOrgOrgIdPlanningTasksIndexRouteImport.update({
    id: '/planning/tasks/',
    path: '/planning/tasks/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute =
  AuthAppAppOrgOrgIdPlanningObjectivesIndexRouteImport.update({
    id: '/planning/objectives/',
    path: '/planning/objectives/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute =
  AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRouteImport.update({
    id: '/my-requests/',
    path: '/my-requests/',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute =
  AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRouteImport.update({
    id: '/my-offers/',
    path: '/my-offers/',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute =
  AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRouteImport.update({
    id: '/incoming-requests/',
    path: '/incoming-requests/',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRouteImport.update({
    id: '/grass-production/cultivars/',
    path: '/grass-production/cultivars/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialVendorsIndexRoute =
  AuthAppAppOrgOrgIdFinancialVendorsIndexRouteImport.update({
    id: '/vendors/',
    path: '/vendors/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute =
  AuthAppAppOrgOrgIdFinancialTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialReportsIndexRoute =
  AuthAppAppOrgOrgIdFinancialReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialRecurringIndexRoute =
  AuthAppAppOrgOrgIdFinancialRecurringIndexRouteImport.update({
    id: '/recurring/',
    path: '/recurring/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute =
  AuthAppAppOrgOrgIdFinancialReceivablesIndexRouteImport.update({
    id: '/receivables/',
    path: '/receivables/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayrollIndexRoute =
  AuthAppAppOrgOrgIdFinancialPayrollIndexRouteImport.update({
    id: '/payroll/',
    path: '/payroll/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayablesIndexRoute =
  AuthAppAppOrgOrgIdFinancialPayablesIndexRouteImport.update({
    id: '/payables/',
    path: '/payables/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialLoansIndexRoute =
  AuthAppAppOrgOrgIdFinancialLoansIndexRouteImport.update({
    id: '/loans/',
    path: '/loans/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute =
  AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRouteImport.update({
    id: '/$studyId/',
    path: '/$studyId/',
    getParentRoute: () => AuthAppAppOrgOrgIdFeasibilityRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute =
  AuthAppAppOrgOrgIdEquipmentScheduleIndexRouteImport.update({
    id: '/schedule/',
    path: '/schedule/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentPartsIndexRoute =
  AuthAppAppOrgOrgIdEquipmentPartsIndexRouteImport.update({
    id: '/parts/',
    path: '/parts/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentFleetIndexRoute =
  AuthAppAppOrgOrgIdEquipmentFleetIndexRouteImport.update({
    id: '/fleet/',
    path: '/fleet/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute =
  AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRouteImport.update({
    id: '/breakdown-report/',
    path: '/breakdown-report/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute =
  AuthAppAppOrgOrgIdStaffStaffIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdStaffStaffIdEditRoute =
  AuthAppAppOrgOrgIdStaffStaffIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdStaffStaffIdRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute =
  AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRouteImport.update({
    id: '/platform-plan/update',
    path: '/platform-plan/update',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute =
  AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRouteImport.update({
    id: '/platform-plan/success',
    path: '/platform-plan/success',
    getParentRoute: () => AuthAppAppOrgOrgIdSettingsRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningTasksKanbanRoute =
  AuthAppAppOrgOrgIdPlanningTasksKanbanRouteImport.update({
    id: '/planning/tasks/kanban',
    path: '/planning/tasks/kanban',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningTasksCalendarRoute =
  AuthAppAppOrgOrgIdPlanningTasksCalendarRouteImport.update({
    id: '/planning/tasks/calendar',
    path: '/planning/tasks/calendar',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute =
  AuthAppAppOrgOrgIdMarketplaceMyOffersNewRouteImport.update({
    id: '/my-offers/new',
    path: '/my-offers/new',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute =
  AuthAppAppOrgOrgIdGrassProductionCultivarsNewRouteImport.update({
    id: '/grass-production/cultivars/new',
    path: '/grass-production/cultivars/new',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialTransactionsNewRoute =
  AuthAppAppOrgOrgIdFinancialTransactionsNewRouteImport.update({
    id: '/transactions/new',
    path: '/transactions/new',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialTransactionsImportRoute =
  AuthAppAppOrgOrgIdFinancialTransactionsImportRouteImport.update({
    id: '/transactions/import',
    path: '/transactions/import',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialRecurringNewRoute =
  AuthAppAppOrgOrgIdFinancialRecurringNewRouteImport.update({
    id: '/recurring/new',
    path: '/recurring/new',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute =
  AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRouteImport.update({
    id: '/receivables/$receivableId',
    path: '/receivables/$receivableId',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayablesNewRoute =
  AuthAppAppOrgOrgIdFinancialPayablesNewRouteImport.update({
    id: '/payables/new',
    path: '/payables/new',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute =
  AuthAppAppOrgOrgIdFinancialPayablesBillIdRouteImport.update({
    id: '/payables/$billId',
    path: '/payables/$billId',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialLoansNewRoute =
  AuthAppAppOrgOrgIdFinancialLoansNewRouteImport.update({
    id: '/loans/new',
    path: '/loans/new',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentPartsNewRoute =
  AuthAppAppOrgOrgIdEquipmentPartsNewRouteImport.update({
    id: '/parts/new',
    path: '/parts/new',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentFleetNewRoute =
  AuthAppAppOrgOrgIdEquipmentFleetNewRouteImport.update({
    id: '/fleet/new',
    path: '/fleet/new',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute =
  AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRouteImport.update({
    id: '/breakdown-report/$reportId',
    path: '/breakdown-report/$reportId',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute =
  AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRouteImport.update({
    id: '/planning/tasks/$taskId/',
    path: '/planning/tasks/$taskId/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute =
  AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRouteImport.update({
    id: '/planning/objectives/$objectiveId/',
    path: '/planning/objectives/$objectiveId/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRouteImport.update({
    id: '/weighing/',
    path: '/weighing/',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRouteImport.update({
    id: '/registries/',
    path: '/registries/',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRouteImport.update({
    id: '/grass-production/farms/$farmId/',
    path: '/grass-production/farms/$farmId/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute =
  AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRouteImport.update({
    id: '/transactions/$transactionId/',
    path: '/transactions/$transactionId/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute =
  AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRouteImport.update({
    id: '/recurring/$templateId/',
    path: '/recurring/$templateId/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute =
  AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRouteImport.update({
    id: '/payroll/workers/',
    path: '/payroll/workers/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute =
  AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRouteImport.update({
    id: '/payroll/labor/',
    path: '/payroll/labor/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute =
  AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRouteImport.update({
    id: '/loans/$loanId/',
    path: '/loans/$loanId/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute =
  AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRouteImport.update({
    id: '/parts/$partId/',
    path: '/parts/$partId/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute =
  AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRouteImport.update({
    id: '/fleet/$equipmentId/',
    path: '/fleet/$equipmentId/',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute =
  AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRouteImport.update({
    id: '/my-offers/$offerId/edit',
    path: '/my-offers/$offerId/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdMarketplaceRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRouteImport.update({
    id: '/herds/new',
    path: '/herds/new',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRouteImport.update({
    id: '/animals/new',
    path: '/animals/new',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRouteImport.update({
    id: '/animals/import',
    path: '/animals/import',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute =
  AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRouteImport.update({
    id: '/grass-production/cultivars/$cultivarId/edit',
    path: '/grass-production/cultivars/$cultivarId/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute =
  AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRouteImport.update({
    id: '/parts/$partId/edit',
    path: '/parts/$partId/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute =
  AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRouteImport.update({
    id: '/fleet/$equipmentId/inspect',
    path: '/fleet/$equipmentId/inspect',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute =
  AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRouteImport.update({
    id: '/fleet/$equipmentId/edit',
    path: '/fleet/$equipmentId/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdEquipmentRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRouteImport.update({
    id: '/herds/$herdId/',
    path: '/herds/$herdId/',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRouteImport.update(
    {
      id: '/animals/$animalId/',
      path: '/animals/$animalId/',
      getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRouteImport.update({
    id: '/grass-production/farms/$farmId/paddocks/',
    path: '/grass-production/farms/$farmId/paddocks/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRouteImport.update({
    id: '/grass-production/farms/$farmId/map/',
    path: '/grass-production/farms/$farmId/map/',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute =
  AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRouteImport.update({
    id: '/payroll/runs/$runId/',
    path: '/payroll/runs/$runId/',
    getParentRoute: () => AuthAppAppOrgOrgIdFinancialRouteRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRouteImport.update({
    id: '/herds/$herdId/edit',
    path: '/herds/$herdId/edit',
    getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
  } as any)
const AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRouteImport.update(
    {
      id: '/animals/$animalId/edit',
      path: '/animals/$animalId/edit',
      getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRouteImport.update(
    {
      id: '/grass-production/farms/$farmId/soil-reports/import',
      path: '/grass-production/farms/$farmId/soil-reports/import',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRouteImport.update({
    id: '/grass-production/farms/$farmId/paddocks/new',
    path: '/grass-production/farms/$farmId/paddocks/new',
    getParentRoute: () => AuthAppAppOrgOrgIdRoute,
  } as any)
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRouteImport.update(
    {
      id: '/grass-production/farms/$farmId/paddocks/$paddockId/',
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRouteImport.update(
    {
      id: '/animals/$animalId/operations/new',
      path: '/animals/$animalId/operations/new',
      getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRouteImport.update(
    {
      id: '/animals/$animalId/measurements/new',
      path: '/animals/$animalId/measurements/new',
      getParentRoute: () => AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRouteImport.update(
    {
      id: '/grass-production/farms/$farmId/paddocks/$paddockId/edit',
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/edit',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRouteImport.update(
    {
      id: '/grass-production/farms/$farmId/paddocks/$paddockId/operations/new',
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/operations/new',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRouteImport.update(
    {
      id: '/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new',
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )
const AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute =
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRouteImport.update(
    {
      id: '/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/',
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/',
      getParentRoute: () => AuthAppAppOrgOrgIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/app': typeof AuthAppAppRouteWithChildren
  '/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/staff-invite/$token': typeof AuthStaffInviteTokenRoute
  '/sign-in/$': typeof PublicSignInSplatRoute
  '/sign-up/$': typeof PublicSignUpSplatRoute
  '/sign-in/': typeof PublicSignInIndexRoute
  '/sign-up/': typeof PublicSignUpIndexRoute
  '/app/help': typeof AuthAppAppHelpRouteWithChildren
  '/app/': typeof AuthAppAppIndexRoute
  '/app/help/support': typeof AuthAppAppHelpSupportRouteWithChildren
  '/app/help/user-guide': typeof AuthAppAppHelpUserGuideRouteWithChildren
  '/app/org/$orgId': typeof AuthAppAppOrgOrgIdRouteWithChildren
  '/app/org/renew-platform-plan': typeof AuthAppAppOrgRenewPlatformPlanRoute
  '/app/help/': typeof AuthAppAppHelpIndexRoute
  '/app/user-settings/': typeof AuthAppAppUserSettingsIndexRoute
  '/app/org/$orgId/feasibility': typeof AuthAppAppOrgOrgIdFeasibilityRouteRouteWithChildren
  '/app/org/$orgId/financial': typeof AuthAppAppOrgOrgIdFinancialRouteRouteWithChildren
  '/app/org/$orgId/marketplace': typeof AuthAppAppOrgOrgIdMarketplaceRouteRouteWithChildren
  '/app/org/$orgId/settings': typeof AuthAppAppOrgOrgIdSettingsRouteRouteWithChildren
  '/app/org/$orgId/staff': typeof AuthAppAppOrgOrgIdStaffRouteRouteWithChildren
  '/app/help/user-guide/assistant': typeof AuthAppAppHelpUserGuideAssistantRoute
  '/app/help/user-guide/equipment': typeof AuthAppAppHelpUserGuideEquipmentRoute
  '/app/help/user-guide/establishments': typeof AuthAppAppHelpUserGuideEstablishmentsRoute
  '/app/help/user-guide/feasibility': typeof AuthAppAppHelpUserGuideFeasibilityRoute
  '/app/help/user-guide/financial': typeof AuthAppAppHelpUserGuideFinancialRoute
  '/app/help/user-guide/grass-production': typeof AuthAppAppHelpUserGuideGrassProductionRoute
  '/app/help/user-guide/livestock': typeof AuthAppAppHelpUserGuideLivestockRoute
  '/app/help/user-guide/marketplace': typeof AuthAppAppHelpUserGuideMarketplaceRoute
  '/app/help/user-guide/planning': typeof AuthAppAppHelpUserGuidePlanningRoute
  '/app/org/$orgId/assistant': typeof AuthAppAppOrgOrgIdAssistantRouteWithChildren
  '/app/org/$orgId/equipment': typeof AuthAppAppOrgOrgIdEquipmentRouteWithChildren
  '/app/org/$orgId/onboarding': typeof AuthAppAppOrgOrgIdOnboardingRoute
  '/app/org/$orgId/under_development': typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  '/app/help/support/': typeof AuthAppAppHelpSupportIndexRoute
  '/app/help/user-guide/': typeof AuthAppAppHelpUserGuideIndexRoute
  '/app/org/$orgId/': typeof AuthAppAppOrgOrgIdIndexRoute
  '/app/help/support/tickets/$ticketId': typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  '/app/org/$orgId/assistant/$conversationId': typeof AuthAppAppOrgOrgIdAssistantConversationIdRoute
  '/app/org/$orgId/feasibility/new': typeof AuthAppAppOrgOrgIdFeasibilityNewRoute
  '/app/org/$orgId/livestock/$establishmentId': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteWithChildren
  '/app/org/$orgId/marketplace/$offerId': typeof AuthAppAppOrgOrgIdMarketplaceOfferIdRoute
  '/app/org/$orgId/staff/$staffId': typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  '/app/help/support/tickets/': typeof AuthAppAppHelpSupportTicketsIndexRoute
  '/app/org/$orgId/assistant/': typeof AuthAppAppOrgOrgIdAssistantIndexRoute
  '/app/org/$orgId/equipment/': typeof AuthAppAppOrgOrgIdEquipmentIndexRoute
  '/app/org/$orgId/establishments/': typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  '/app/org/$orgId/feasibility/': typeof AuthAppAppOrgOrgIdFeasibilityIndexRoute
  '/app/org/$orgId/financial/': typeof AuthAppAppOrgOrgIdFinancialIndexRoute
  '/app/org/$orgId/grass-production/': typeof AuthAppAppOrgOrgIdGrassProductionIndexRoute
  '/app/org/$orgId/livestock/': typeof AuthAppAppOrgOrgIdLivestockIndexRoute
  '/app/org/$orgId/marketplace/': typeof AuthAppAppOrgOrgIdMarketplaceIndexRoute
  '/app/org/$orgId/mcp/': typeof AuthAppAppOrgOrgIdMcpIndexRoute
  '/app/org/$orgId/offline-center/': typeof AuthAppAppOrgOrgIdOfflineCenterIndexRoute
  '/app/org/$orgId/pending-actions/': typeof AuthAppAppOrgOrgIdPendingActionsIndexRoute
  '/app/org/$orgId/planning/': typeof AuthAppAppOrgOrgIdPlanningIndexRoute
  '/app/org/$orgId/settings/': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/app/org/$orgId/staff/': typeof AuthAppAppOrgOrgIdStaffIndexRoute
  '/app/org/$orgId/equipment/breakdown-report/$reportId': typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute
  '/app/org/$orgId/equipment/fleet/new': typeof AuthAppAppOrgOrgIdEquipmentFleetNewRoute
  '/app/org/$orgId/equipment/parts/new': typeof AuthAppAppOrgOrgIdEquipmentPartsNewRoute
  '/app/org/$orgId/financial/loans/new': typeof AuthAppAppOrgOrgIdFinancialLoansNewRoute
  '/app/org/$orgId/financial/payables/$billId': typeof AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute
  '/app/org/$orgId/financial/payables/new': typeof AuthAppAppOrgOrgIdFinancialPayablesNewRoute
  '/app/org/$orgId/financial/receivables/$receivableId': typeof AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute
  '/app/org/$orgId/financial/recurring/new': typeof AuthAppAppOrgOrgIdFinancialRecurringNewRoute
  '/app/org/$orgId/financial/transactions/import': typeof AuthAppAppOrgOrgIdFinancialTransactionsImportRoute
  '/app/org/$orgId/financial/transactions/new': typeof AuthAppAppOrgOrgIdFinancialTransactionsNewRoute
  '/app/org/$orgId/grass-production/cultivars/new': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute
  '/app/org/$orgId/marketplace/my-offers/new': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute
  '/app/org/$orgId/planning/tasks/calendar': typeof AuthAppAppOrgOrgIdPlanningTasksCalendarRoute
  '/app/org/$orgId/planning/tasks/kanban': typeof AuthAppAppOrgOrgIdPlanningTasksKanbanRoute
  '/app/org/$orgId/settings/platform-plan/success': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute
  '/app/org/$orgId/settings/platform-plan/update': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute
  '/app/org/$orgId/staff/$staffId/edit': typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  '/app/org/$orgId/staff/$staffId/permissions': typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  '/app/org/$orgId/equipment/breakdown-report/': typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute
  '/app/org/$orgId/equipment/fleet/': typeof AuthAppAppOrgOrgIdEquipmentFleetIndexRoute
  '/app/org/$orgId/equipment/parts/': typeof AuthAppAppOrgOrgIdEquipmentPartsIndexRoute
  '/app/org/$orgId/equipment/schedule/': typeof AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute
  '/app/org/$orgId/feasibility/$studyId/': typeof AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute
  '/app/org/$orgId/financial/loans/': typeof AuthAppAppOrgOrgIdFinancialLoansIndexRoute
  '/app/org/$orgId/financial/payables/': typeof AuthAppAppOrgOrgIdFinancialPayablesIndexRoute
  '/app/org/$orgId/financial/payroll/': typeof AuthAppAppOrgOrgIdFinancialPayrollIndexRoute
  '/app/org/$orgId/financial/receivables/': typeof AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute
  '/app/org/$orgId/financial/recurring/': typeof AuthAppAppOrgOrgIdFinancialRecurringIndexRoute
  '/app/org/$orgId/financial/reports/': typeof AuthAppAppOrgOrgIdFinancialReportsIndexRoute
  '/app/org/$orgId/financial/transactions/': typeof AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute
  '/app/org/$orgId/financial/vendors/': typeof AuthAppAppOrgOrgIdFinancialVendorsIndexRoute
  '/app/org/$orgId/grass-production/cultivars/': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute
  '/app/org/$orgId/marketplace/incoming-requests/': typeof AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute
  '/app/org/$orgId/marketplace/my-offers/': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute
  '/app/org/$orgId/marketplace/my-requests/': typeof AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute
  '/app/org/$orgId/planning/objectives/': typeof AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute
  '/app/org/$orgId/planning/tasks/': typeof AuthAppAppOrgOrgIdPlanningTasksIndexRoute
  '/app/org/$orgId/settings/ai-keys/': typeof AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute
  '/app/org/$orgId/settings/establishments/': typeof AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute
  '/app/org/$orgId/settings/financial/': typeof AuthAppAppOrgOrgIdSettingsFinancialIndexRoute
  '/app/org/$orgId/settings/livestock/': typeof AuthAppAppOrgOrgIdSettingsLivestockIndexRoute
  '/app/org/$orgId/settings/platform-plan/': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute
  '/app/org/$orgId/equipment/fleet/$equipmentId/edit': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute
  '/app/org/$orgId/equipment/fleet/$equipmentId/inspect': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute
  '/app/org/$orgId/equipment/parts/$partId/edit': typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute
  '/app/org/$orgId/grass-production/cultivars/$cultivarId/edit': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/import': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute
  '/app/org/$orgId/livestock/$establishmentId/herds/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute
  '/app/org/$orgId/marketplace/my-offers/$offerId/edit': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute
  '/app/org/$orgId/equipment/fleet/$equipmentId/': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute
  '/app/org/$orgId/equipment/parts/$partId/': typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute
  '/app/org/$orgId/financial/loans/$loanId/': typeof AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute
  '/app/org/$orgId/financial/payroll/labor/': typeof AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute
  '/app/org/$orgId/financial/payroll/workers/': typeof AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute
  '/app/org/$orgId/financial/recurring/$templateId/': typeof AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute
  '/app/org/$orgId/financial/transactions/$transactionId/': typeof AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/registries/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/weighing/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute
  '/app/org/$orgId/planning/objectives/$objectiveId/': typeof AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute
  '/app/org/$orgId/planning/tasks/$taskId/': typeof AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/soil-reports/import': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute
  '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute
  '/app/org/$orgId/financial/payroll/runs/$runId/': typeof AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/map/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/staff-invite/$token': typeof AuthStaffInviteTokenRoute
  '/sign-in/$': typeof PublicSignInSplatRoute
  '/sign-up/$': typeof PublicSignUpSplatRoute
  '/sign-in': typeof PublicSignInIndexRoute
  '/sign-up': typeof PublicSignUpIndexRoute
  '/app': typeof AuthAppAppIndexRoute
  '/app/org/renew-platform-plan': typeof AuthAppAppOrgRenewPlatformPlanRoute
  '/app/help': typeof AuthAppAppHelpIndexRoute
  '/app/user-settings': typeof AuthAppAppUserSettingsIndexRoute
  '/app/help/user-guide/assistant': typeof AuthAppAppHelpUserGuideAssistantRoute
  '/app/help/user-guide/equipment': typeof AuthAppAppHelpUserGuideEquipmentRoute
  '/app/help/user-guide/establishments': typeof AuthAppAppHelpUserGuideEstablishmentsRoute
  '/app/help/user-guide/feasibility': typeof AuthAppAppHelpUserGuideFeasibilityRoute
  '/app/help/user-guide/financial': typeof AuthAppAppHelpUserGuideFinancialRoute
  '/app/help/user-guide/grass-production': typeof AuthAppAppHelpUserGuideGrassProductionRoute
  '/app/help/user-guide/livestock': typeof AuthAppAppHelpUserGuideLivestockRoute
  '/app/help/user-guide/marketplace': typeof AuthAppAppHelpUserGuideMarketplaceRoute
  '/app/help/user-guide/planning': typeof AuthAppAppHelpUserGuidePlanningRoute
  '/app/org/$orgId/onboarding': typeof AuthAppAppOrgOrgIdOnboardingRoute
  '/app/org/$orgId/under_development': typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  '/app/help/support': typeof AuthAppAppHelpSupportIndexRoute
  '/app/help/user-guide': typeof AuthAppAppHelpUserGuideIndexRoute
  '/app/org/$orgId': typeof AuthAppAppOrgOrgIdIndexRoute
  '/app/help/support/tickets/$ticketId': typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  '/app/org/$orgId/assistant/$conversationId': typeof AuthAppAppOrgOrgIdAssistantConversationIdRoute
  '/app/org/$orgId/feasibility/new': typeof AuthAppAppOrgOrgIdFeasibilityNewRoute
  '/app/org/$orgId/marketplace/$offerId': typeof AuthAppAppOrgOrgIdMarketplaceOfferIdRoute
  '/app/org/$orgId/staff/$staffId': typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  '/app/help/support/tickets': typeof AuthAppAppHelpSupportTicketsIndexRoute
  '/app/org/$orgId/assistant': typeof AuthAppAppOrgOrgIdAssistantIndexRoute
  '/app/org/$orgId/equipment': typeof AuthAppAppOrgOrgIdEquipmentIndexRoute
  '/app/org/$orgId/establishments': typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  '/app/org/$orgId/feasibility': typeof AuthAppAppOrgOrgIdFeasibilityIndexRoute
  '/app/org/$orgId/financial': typeof AuthAppAppOrgOrgIdFinancialIndexRoute
  '/app/org/$orgId/grass-production': typeof AuthAppAppOrgOrgIdGrassProductionIndexRoute
  '/app/org/$orgId/livestock': typeof AuthAppAppOrgOrgIdLivestockIndexRoute
  '/app/org/$orgId/marketplace': typeof AuthAppAppOrgOrgIdMarketplaceIndexRoute
  '/app/org/$orgId/mcp': typeof AuthAppAppOrgOrgIdMcpIndexRoute
  '/app/org/$orgId/offline-center': typeof AuthAppAppOrgOrgIdOfflineCenterIndexRoute
  '/app/org/$orgId/pending-actions': typeof AuthAppAppOrgOrgIdPendingActionsIndexRoute
  '/app/org/$orgId/planning': typeof AuthAppAppOrgOrgIdPlanningIndexRoute
  '/app/org/$orgId/settings': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/app/org/$orgId/staff': typeof AuthAppAppOrgOrgIdStaffIndexRoute
  '/app/org/$orgId/equipment/breakdown-report/$reportId': typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute
  '/app/org/$orgId/equipment/fleet/new': typeof AuthAppAppOrgOrgIdEquipmentFleetNewRoute
  '/app/org/$orgId/equipment/parts/new': typeof AuthAppAppOrgOrgIdEquipmentPartsNewRoute
  '/app/org/$orgId/financial/loans/new': typeof AuthAppAppOrgOrgIdFinancialLoansNewRoute
  '/app/org/$orgId/financial/payables/$billId': typeof AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute
  '/app/org/$orgId/financial/payables/new': typeof AuthAppAppOrgOrgIdFinancialPayablesNewRoute
  '/app/org/$orgId/financial/receivables/$receivableId': typeof AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute
  '/app/org/$orgId/financial/recurring/new': typeof AuthAppAppOrgOrgIdFinancialRecurringNewRoute
  '/app/org/$orgId/financial/transactions/import': typeof AuthAppAppOrgOrgIdFinancialTransactionsImportRoute
  '/app/org/$orgId/financial/transactions/new': typeof AuthAppAppOrgOrgIdFinancialTransactionsNewRoute
  '/app/org/$orgId/grass-production/cultivars/new': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute
  '/app/org/$orgId/marketplace/my-offers/new': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute
  '/app/org/$orgId/planning/tasks/calendar': typeof AuthAppAppOrgOrgIdPlanningTasksCalendarRoute
  '/app/org/$orgId/planning/tasks/kanban': typeof AuthAppAppOrgOrgIdPlanningTasksKanbanRoute
  '/app/org/$orgId/settings/platform-plan/success': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute
  '/app/org/$orgId/settings/platform-plan/update': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute
  '/app/org/$orgId/staff/$staffId/edit': typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  '/app/org/$orgId/staff/$staffId/permissions': typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  '/app/org/$orgId/equipment/breakdown-report': typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute
  '/app/org/$orgId/equipment/fleet': typeof AuthAppAppOrgOrgIdEquipmentFleetIndexRoute
  '/app/org/$orgId/equipment/parts': typeof AuthAppAppOrgOrgIdEquipmentPartsIndexRoute
  '/app/org/$orgId/equipment/schedule': typeof AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute
  '/app/org/$orgId/feasibility/$studyId': typeof AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute
  '/app/org/$orgId/financial/loans': typeof AuthAppAppOrgOrgIdFinancialLoansIndexRoute
  '/app/org/$orgId/financial/payables': typeof AuthAppAppOrgOrgIdFinancialPayablesIndexRoute
  '/app/org/$orgId/financial/payroll': typeof AuthAppAppOrgOrgIdFinancialPayrollIndexRoute
  '/app/org/$orgId/financial/receivables': typeof AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute
  '/app/org/$orgId/financial/recurring': typeof AuthAppAppOrgOrgIdFinancialRecurringIndexRoute
  '/app/org/$orgId/financial/reports': typeof AuthAppAppOrgOrgIdFinancialReportsIndexRoute
  '/app/org/$orgId/financial/transactions': typeof AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute
  '/app/org/$orgId/financial/vendors': typeof AuthAppAppOrgOrgIdFinancialVendorsIndexRoute
  '/app/org/$orgId/grass-production/cultivars': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute
  '/app/org/$orgId/livestock/$establishmentId': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute
  '/app/org/$orgId/marketplace/incoming-requests': typeof AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute
  '/app/org/$orgId/marketplace/my-offers': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute
  '/app/org/$orgId/marketplace/my-requests': typeof AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute
  '/app/org/$orgId/planning/objectives': typeof AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute
  '/app/org/$orgId/planning/tasks': typeof AuthAppAppOrgOrgIdPlanningTasksIndexRoute
  '/app/org/$orgId/settings/ai-keys': typeof AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute
  '/app/org/$orgId/settings/establishments': typeof AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute
  '/app/org/$orgId/settings/financial': typeof AuthAppAppOrgOrgIdSettingsFinancialIndexRoute
  '/app/org/$orgId/settings/livestock': typeof AuthAppAppOrgOrgIdSettingsLivestockIndexRoute
  '/app/org/$orgId/settings/platform-plan': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute
  '/app/org/$orgId/equipment/fleet/$equipmentId/edit': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute
  '/app/org/$orgId/equipment/fleet/$equipmentId/inspect': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute
  '/app/org/$orgId/equipment/parts/$partId/edit': typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute
  '/app/org/$orgId/grass-production/cultivars/$cultivarId/edit': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/import': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute
  '/app/org/$orgId/livestock/$establishmentId/herds/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute
  '/app/org/$orgId/marketplace/my-offers/$offerId/edit': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute
  '/app/org/$orgId/equipment/fleet/$equipmentId': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute
  '/app/org/$orgId/equipment/parts/$partId': typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute
  '/app/org/$orgId/financial/loans/$loanId': typeof AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute
  '/app/org/$orgId/financial/payroll/labor': typeof AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute
  '/app/org/$orgId/financial/payroll/workers': typeof AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute
  '/app/org/$orgId/financial/recurring/$templateId': typeof AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute
  '/app/org/$orgId/financial/transactions/$transactionId': typeof AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/registries': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/weighing': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute
  '/app/org/$orgId/planning/objectives/$objectiveId': typeof AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute
  '/app/org/$orgId/planning/tasks/$taskId': typeof AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/soil-reports/import': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute
  '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute
  '/app/org/$orgId/financial/payroll/runs/$runId': typeof AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/map': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute
  '/app/org/$orgId/livestock/$establishmentId/herds/$herdId': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute
  '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute
  '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/': typeof PublicIndexRoute
  '/_auth/app/_app': typeof AuthAppAppRouteWithChildren
  '/_auth/app/select-organization': typeof AuthAppSelectOrganizationRoute
  '/_auth/staff-invite/$token': typeof AuthStaffInviteTokenRoute
  '/_public/sign-in/$': typeof PublicSignInSplatRoute
  '/_public/sign-up/$': typeof PublicSignUpSplatRoute
  '/_public/sign-in/': typeof PublicSignInIndexRoute
  '/_public/sign-up/': typeof PublicSignUpIndexRoute
  '/_auth/app/_app/help': typeof AuthAppAppHelpRouteWithChildren
  '/_auth/app/_app/': typeof AuthAppAppIndexRoute
  '/_auth/app/_app/help/support': typeof AuthAppAppHelpSupportRouteWithChildren
  '/_auth/app/_app/help/user-guide': typeof AuthAppAppHelpUserGuideRouteWithChildren
  '/_auth/app/_app/org/$orgId': typeof AuthAppAppOrgOrgIdRouteWithChildren
  '/_auth/app/_app/org/renew-platform-plan': typeof AuthAppAppOrgRenewPlatformPlanRoute
  '/_auth/app/_app/help/': typeof AuthAppAppHelpIndexRoute
  '/_auth/app/_app/user-settings/': typeof AuthAppAppUserSettingsIndexRoute
  '/_auth/app/_app/org/$orgId/feasibility': typeof AuthAppAppOrgOrgIdFeasibilityRouteRouteWithChildren
  '/_auth/app/_app/org/$orgId/financial': typeof AuthAppAppOrgOrgIdFinancialRouteRouteWithChildren
  '/_auth/app/_app/org/$orgId/marketplace': typeof AuthAppAppOrgOrgIdMarketplaceRouteRouteWithChildren
  '/_auth/app/_app/org/$orgId/settings': typeof AuthAppAppOrgOrgIdSettingsRouteRouteWithChildren
  '/_auth/app/_app/org/$orgId/staff': typeof AuthAppAppOrgOrgIdStaffRouteRouteWithChildren
  '/_auth/app/_app/help/user-guide/assistant': typeof AuthAppAppHelpUserGuideAssistantRoute
  '/_auth/app/_app/help/user-guide/equipment': typeof AuthAppAppHelpUserGuideEquipmentRoute
  '/_auth/app/_app/help/user-guide/establishments': typeof AuthAppAppHelpUserGuideEstablishmentsRoute
  '/_auth/app/_app/help/user-guide/feasibility': typeof AuthAppAppHelpUserGuideFeasibilityRoute
  '/_auth/app/_app/help/user-guide/financial': typeof AuthAppAppHelpUserGuideFinancialRoute
  '/_auth/app/_app/help/user-guide/grass-production': typeof AuthAppAppHelpUserGuideGrassProductionRoute
  '/_auth/app/_app/help/user-guide/livestock': typeof AuthAppAppHelpUserGuideLivestockRoute
  '/_auth/app/_app/help/user-guide/marketplace': typeof AuthAppAppHelpUserGuideMarketplaceRoute
  '/_auth/app/_app/help/user-guide/planning': typeof AuthAppAppHelpUserGuidePlanningRoute
  '/_auth/app/_app/org/$orgId/assistant': typeof AuthAppAppOrgOrgIdAssistantRouteWithChildren
  '/_auth/app/_app/org/$orgId/equipment': typeof AuthAppAppOrgOrgIdEquipmentRouteWithChildren
  '/_auth/app/_app/org/$orgId/onboarding': typeof AuthAppAppOrgOrgIdOnboardingRoute
  '/_auth/app/_app/org/$orgId/under_development': typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  '/_auth/app/_app/help/support/': typeof AuthAppAppHelpSupportIndexRoute
  '/_auth/app/_app/help/user-guide/': typeof AuthAppAppHelpUserGuideIndexRoute
  '/_auth/app/_app/org/$orgId/': typeof AuthAppAppOrgOrgIdIndexRoute
  '/_auth/app/_app/help/support/tickets/$ticketId': typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  '/_auth/app/_app/org/$orgId/assistant/$conversationId': typeof AuthAppAppOrgOrgIdAssistantConversationIdRoute
  '/_auth/app/_app/org/$orgId/feasibility/new': typeof AuthAppAppOrgOrgIdFeasibilityNewRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteWithChildren
  '/_auth/app/_app/org/$orgId/marketplace/$offerId': typeof AuthAppAppOrgOrgIdMarketplaceOfferIdRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId': typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  '/_auth/app/_app/help/support/tickets/': typeof AuthAppAppHelpSupportTicketsIndexRoute
  '/_auth/app/_app/org/$orgId/assistant/': typeof AuthAppAppOrgOrgIdAssistantIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/': typeof AuthAppAppOrgOrgIdEquipmentIndexRoute
  '/_auth/app/_app/org/$orgId/establishments/': typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  '/_auth/app/_app/org/$orgId/feasibility/': typeof AuthAppAppOrgOrgIdFeasibilityIndexRoute
  '/_auth/app/_app/org/$orgId/financial/': typeof AuthAppAppOrgOrgIdFinancialIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/': typeof AuthAppAppOrgOrgIdGrassProductionIndexRoute
  '/_auth/app/_app/org/$orgId/livestock/': typeof AuthAppAppOrgOrgIdLivestockIndexRoute
  '/_auth/app/_app/org/$orgId/marketplace/': typeof AuthAppAppOrgOrgIdMarketplaceIndexRoute
  '/_auth/app/_app/org/$orgId/mcp/': typeof AuthAppAppOrgOrgIdMcpIndexRoute
  '/_auth/app/_app/org/$orgId/offline-center/': typeof AuthAppAppOrgOrgIdOfflineCenterIndexRoute
  '/_auth/app/_app/org/$orgId/pending-actions/': typeof AuthAppAppOrgOrgIdPendingActionsIndexRoute
  '/_auth/app/_app/org/$orgId/planning/': typeof AuthAppAppOrgOrgIdPlanningIndexRoute
  '/_auth/app/_app/org/$orgId/settings/': typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  '/_auth/app/_app/org/$orgId/staff/': typeof AuthAppAppOrgOrgIdStaffIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/breakdown-report/$reportId': typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute
  '/_auth/app/_app/org/$orgId/equipment/fleet/new': typeof AuthAppAppOrgOrgIdEquipmentFleetNewRoute
  '/_auth/app/_app/org/$orgId/equipment/parts/new': typeof AuthAppAppOrgOrgIdEquipmentPartsNewRoute
  '/_auth/app/_app/org/$orgId/financial/loans/new': typeof AuthAppAppOrgOrgIdFinancialLoansNewRoute
  '/_auth/app/_app/org/$orgId/financial/payables/$billId': typeof AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute
  '/_auth/app/_app/org/$orgId/financial/payables/new': typeof AuthAppAppOrgOrgIdFinancialPayablesNewRoute
  '/_auth/app/_app/org/$orgId/financial/receivables/$receivableId': typeof AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute
  '/_auth/app/_app/org/$orgId/financial/recurring/new': typeof AuthAppAppOrgOrgIdFinancialRecurringNewRoute
  '/_auth/app/_app/org/$orgId/financial/transactions/import': typeof AuthAppAppOrgOrgIdFinancialTransactionsImportRoute
  '/_auth/app/_app/org/$orgId/financial/transactions/new': typeof AuthAppAppOrgOrgIdFinancialTransactionsNewRoute
  '/_auth/app/_app/org/$orgId/grass-production/cultivars/new': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute
  '/_auth/app/_app/org/$orgId/marketplace/my-offers/new': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute
  '/_auth/app/_app/org/$orgId/planning/tasks/calendar': typeof AuthAppAppOrgOrgIdPlanningTasksCalendarRoute
  '/_auth/app/_app/org/$orgId/planning/tasks/kanban': typeof AuthAppAppOrgOrgIdPlanningTasksKanbanRoute
  '/_auth/app/_app/org/$orgId/settings/platform-plan/success': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute
  '/_auth/app/_app/org/$orgId/settings/platform-plan/update': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/edit': typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  '/_auth/app/_app/org/$orgId/staff/$staffId/permissions': typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
  '/_auth/app/_app/org/$orgId/equipment/breakdown-report/': typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/fleet/': typeof AuthAppAppOrgOrgIdEquipmentFleetIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/parts/': typeof AuthAppAppOrgOrgIdEquipmentPartsIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/schedule/': typeof AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute
  '/_auth/app/_app/org/$orgId/feasibility/$studyId/': typeof AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute
  '/_auth/app/_app/org/$orgId/financial/loans/': typeof AuthAppAppOrgOrgIdFinancialLoansIndexRoute
  '/_auth/app/_app/org/$orgId/financial/payables/': typeof AuthAppAppOrgOrgIdFinancialPayablesIndexRoute
  '/_auth/app/_app/org/$orgId/financial/payroll/': typeof AuthAppAppOrgOrgIdFinancialPayrollIndexRoute
  '/_auth/app/_app/org/$orgId/financial/receivables/': typeof AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute
  '/_auth/app/_app/org/$orgId/financial/recurring/': typeof AuthAppAppOrgOrgIdFinancialRecurringIndexRoute
  '/_auth/app/_app/org/$orgId/financial/reports/': typeof AuthAppAppOrgOrgIdFinancialReportsIndexRoute
  '/_auth/app/_app/org/$orgId/financial/transactions/': typeof AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute
  '/_auth/app/_app/org/$orgId/financial/vendors/': typeof AuthAppAppOrgOrgIdFinancialVendorsIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/cultivars/': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute
  '/_auth/app/_app/org/$orgId/marketplace/incoming-requests/': typeof AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute
  '/_auth/app/_app/org/$orgId/marketplace/my-offers/': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute
  '/_auth/app/_app/org/$orgId/marketplace/my-requests/': typeof AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute
  '/_auth/app/_app/org/$orgId/planning/objectives/': typeof AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute
  '/_auth/app/_app/org/$orgId/planning/tasks/': typeof AuthAppAppOrgOrgIdPlanningTasksIndexRoute
  '/_auth/app/_app/org/$orgId/settings/ai-keys/': typeof AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute
  '/_auth/app/_app/org/$orgId/settings/establishments/': typeof AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute
  '/_auth/app/_app/org/$orgId/settings/financial/': typeof AuthAppAppOrgOrgIdSettingsFinancialIndexRoute
  '/_auth/app/_app/org/$orgId/settings/livestock/': typeof AuthAppAppOrgOrgIdSettingsLivestockIndexRoute
  '/_auth/app/_app/org/$orgId/settings/platform-plan/': typeof AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/edit': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute
  '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/inspect': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute
  '/_auth/app/_app/org/$orgId/equipment/parts/$partId/edit': typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute
  '/_auth/app/_app/org/$orgId/grass-production/cultivars/$cultivarId/edit': typeof AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/import': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute
  '/_auth/app/_app/org/$orgId/marketplace/my-offers/$offerId/edit': typeof AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute
  '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/': typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute
  '/_auth/app/_app/org/$orgId/equipment/parts/$partId/': typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute
  '/_auth/app/_app/org/$orgId/financial/loans/$loanId/': typeof AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute
  '/_auth/app/_app/org/$orgId/financial/payroll/labor/': typeof AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute
  '/_auth/app/_app/org/$orgId/financial/payroll/workers/': typeof AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute
  '/_auth/app/_app/org/$orgId/financial/recurring/$templateId/': typeof AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute
  '/_auth/app/_app/org/$orgId/financial/transactions/$transactionId/': typeof AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/registries/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/weighing/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute
  '/_auth/app/_app/org/$orgId/planning/objectives/$objectiveId/': typeof AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute
  '/_auth/app/_app/org/$orgId/planning/tasks/$taskId/': typeof AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/soil-reports/import': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute
  '/_auth/app/_app/org/$orgId/financial/payroll/runs/$runId/': typeof AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/map/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute
  '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new': typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute
  '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/': typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/app/select-organization'
    | '/staff-invite/$token'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/sign-in/'
    | '/sign-up/'
    | '/app/help'
    | '/app/'
    | '/app/help/support'
    | '/app/help/user-guide'
    | '/app/org/$orgId'
    | '/app/org/renew-platform-plan'
    | '/app/help/'
    | '/app/user-settings/'
    | '/app/org/$orgId/feasibility'
    | '/app/org/$orgId/financial'
    | '/app/org/$orgId/marketplace'
    | '/app/org/$orgId/settings'
    | '/app/org/$orgId/staff'
    | '/app/help/user-guide/assistant'
    | '/app/help/user-guide/equipment'
    | '/app/help/user-guide/establishments'
    | '/app/help/user-guide/feasibility'
    | '/app/help/user-guide/financial'
    | '/app/help/user-guide/grass-production'
    | '/app/help/user-guide/livestock'
    | '/app/help/user-guide/marketplace'
    | '/app/help/user-guide/planning'
    | '/app/org/$orgId/assistant'
    | '/app/org/$orgId/equipment'
    | '/app/org/$orgId/onboarding'
    | '/app/org/$orgId/under_development'
    | '/app/help/support/'
    | '/app/help/user-guide/'
    | '/app/org/$orgId/'
    | '/app/help/support/tickets/$ticketId'
    | '/app/org/$orgId/assistant/$conversationId'
    | '/app/org/$orgId/feasibility/new'
    | '/app/org/$orgId/livestock/$establishmentId'
    | '/app/org/$orgId/marketplace/$offerId'
    | '/app/org/$orgId/staff/$staffId'
    | '/app/help/support/tickets/'
    | '/app/org/$orgId/assistant/'
    | '/app/org/$orgId/equipment/'
    | '/app/org/$orgId/establishments/'
    | '/app/org/$orgId/feasibility/'
    | '/app/org/$orgId/financial/'
    | '/app/org/$orgId/grass-production/'
    | '/app/org/$orgId/livestock/'
    | '/app/org/$orgId/marketplace/'
    | '/app/org/$orgId/mcp/'
    | '/app/org/$orgId/offline-center/'
    | '/app/org/$orgId/pending-actions/'
    | '/app/org/$orgId/planning/'
    | '/app/org/$orgId/settings/'
    | '/app/org/$orgId/staff/'
    | '/app/org/$orgId/equipment/breakdown-report/$reportId'
    | '/app/org/$orgId/equipment/fleet/new'
    | '/app/org/$orgId/equipment/parts/new'
    | '/app/org/$orgId/financial/loans/new'
    | '/app/org/$orgId/financial/payables/$billId'
    | '/app/org/$orgId/financial/payables/new'
    | '/app/org/$orgId/financial/receivables/$receivableId'
    | '/app/org/$orgId/financial/recurring/new'
    | '/app/org/$orgId/financial/transactions/import'
    | '/app/org/$orgId/financial/transactions/new'
    | '/app/org/$orgId/grass-production/cultivars/new'
    | '/app/org/$orgId/marketplace/my-offers/new'
    | '/app/org/$orgId/planning/tasks/calendar'
    | '/app/org/$orgId/planning/tasks/kanban'
    | '/app/org/$orgId/settings/platform-plan/success'
    | '/app/org/$orgId/settings/platform-plan/update'
    | '/app/org/$orgId/staff/$staffId/edit'
    | '/app/org/$orgId/staff/$staffId/permissions'
    | '/app/org/$orgId/equipment/breakdown-report/'
    | '/app/org/$orgId/equipment/fleet/'
    | '/app/org/$orgId/equipment/parts/'
    | '/app/org/$orgId/equipment/schedule/'
    | '/app/org/$orgId/feasibility/$studyId/'
    | '/app/org/$orgId/financial/loans/'
    | '/app/org/$orgId/financial/payables/'
    | '/app/org/$orgId/financial/payroll/'
    | '/app/org/$orgId/financial/receivables/'
    | '/app/org/$orgId/financial/recurring/'
    | '/app/org/$orgId/financial/reports/'
    | '/app/org/$orgId/financial/transactions/'
    | '/app/org/$orgId/financial/vendors/'
    | '/app/org/$orgId/grass-production/cultivars/'
    | '/app/org/$orgId/livestock/$establishmentId/'
    | '/app/org/$orgId/marketplace/incoming-requests/'
    | '/app/org/$orgId/marketplace/my-offers/'
    | '/app/org/$orgId/marketplace/my-requests/'
    | '/app/org/$orgId/planning/objectives/'
    | '/app/org/$orgId/planning/tasks/'
    | '/app/org/$orgId/settings/ai-keys/'
    | '/app/org/$orgId/settings/establishments/'
    | '/app/org/$orgId/settings/financial/'
    | '/app/org/$orgId/settings/livestock/'
    | '/app/org/$orgId/settings/platform-plan/'
    | '/app/org/$orgId/equipment/fleet/$equipmentId/edit'
    | '/app/org/$orgId/equipment/fleet/$equipmentId/inspect'
    | '/app/org/$orgId/equipment/parts/$partId/edit'
    | '/app/org/$orgId/grass-production/cultivars/$cultivarId/edit'
    | '/app/org/$orgId/livestock/$establishmentId/animals/import'
    | '/app/org/$orgId/livestock/$establishmentId/animals/new'
    | '/app/org/$orgId/livestock/$establishmentId/herds/new'
    | '/app/org/$orgId/marketplace/my-offers/$offerId/edit'
    | '/app/org/$orgId/equipment/fleet/$equipmentId/'
    | '/app/org/$orgId/equipment/parts/$partId/'
    | '/app/org/$orgId/financial/loans/$loanId/'
    | '/app/org/$orgId/financial/payroll/labor/'
    | '/app/org/$orgId/financial/payroll/workers/'
    | '/app/org/$orgId/financial/recurring/$templateId/'
    | '/app/org/$orgId/financial/transactions/$transactionId/'
    | '/app/org/$orgId/grass-production/farms/$farmId/'
    | '/app/org/$orgId/livestock/$establishmentId/registries/'
    | '/app/org/$orgId/livestock/$establishmentId/weighing/'
    | '/app/org/$orgId/planning/objectives/$objectiveId/'
    | '/app/org/$orgId/planning/tasks/$taskId/'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/soil-reports/import'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit'
    | '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit'
    | '/app/org/$orgId/financial/payroll/runs/$runId/'
    | '/app/org/$orgId/grass-production/farms/$farmId/map/'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/'
    | '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app/select-organization'
    | '/staff-invite/$token'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/sign-in'
    | '/sign-up'
    | '/app'
    | '/app/org/renew-platform-plan'
    | '/app/help'
    | '/app/user-settings'
    | '/app/help/user-guide/assistant'
    | '/app/help/user-guide/equipment'
    | '/app/help/user-guide/establishments'
    | '/app/help/user-guide/feasibility'
    | '/app/help/user-guide/financial'
    | '/app/help/user-guide/grass-production'
    | '/app/help/user-guide/livestock'
    | '/app/help/user-guide/marketplace'
    | '/app/help/user-guide/planning'
    | '/app/org/$orgId/onboarding'
    | '/app/org/$orgId/under_development'
    | '/app/help/support'
    | '/app/help/user-guide'
    | '/app/org/$orgId'
    | '/app/help/support/tickets/$ticketId'
    | '/app/org/$orgId/assistant/$conversationId'
    | '/app/org/$orgId/feasibility/new'
    | '/app/org/$orgId/marketplace/$offerId'
    | '/app/org/$orgId/staff/$staffId'
    | '/app/help/support/tickets'
    | '/app/org/$orgId/assistant'
    | '/app/org/$orgId/equipment'
    | '/app/org/$orgId/establishments'
    | '/app/org/$orgId/feasibility'
    | '/app/org/$orgId/financial'
    | '/app/org/$orgId/grass-production'
    | '/app/org/$orgId/livestock'
    | '/app/org/$orgId/marketplace'
    | '/app/org/$orgId/mcp'
    | '/app/org/$orgId/offline-center'
    | '/app/org/$orgId/pending-actions'
    | '/app/org/$orgId/planning'
    | '/app/org/$orgId/settings'
    | '/app/org/$orgId/staff'
    | '/app/org/$orgId/equipment/breakdown-report/$reportId'
    | '/app/org/$orgId/equipment/fleet/new'
    | '/app/org/$orgId/equipment/parts/new'
    | '/app/org/$orgId/financial/loans/new'
    | '/app/org/$orgId/financial/payables/$billId'
    | '/app/org/$orgId/financial/payables/new'
    | '/app/org/$orgId/financial/receivables/$receivableId'
    | '/app/org/$orgId/financial/recurring/new'
    | '/app/org/$orgId/financial/transactions/import'
    | '/app/org/$orgId/financial/transactions/new'
    | '/app/org/$orgId/grass-production/cultivars/new'
    | '/app/org/$orgId/marketplace/my-offers/new'
    | '/app/org/$orgId/planning/tasks/calendar'
    | '/app/org/$orgId/planning/tasks/kanban'
    | '/app/org/$orgId/settings/platform-plan/success'
    | '/app/org/$orgId/settings/platform-plan/update'
    | '/app/org/$orgId/staff/$staffId/edit'
    | '/app/org/$orgId/staff/$staffId/permissions'
    | '/app/org/$orgId/equipment/breakdown-report'
    | '/app/org/$orgId/equipment/fleet'
    | '/app/org/$orgId/equipment/parts'
    | '/app/org/$orgId/equipment/schedule'
    | '/app/org/$orgId/feasibility/$studyId'
    | '/app/org/$orgId/financial/loans'
    | '/app/org/$orgId/financial/payables'
    | '/app/org/$orgId/financial/payroll'
    | '/app/org/$orgId/financial/receivables'
    | '/app/org/$orgId/financial/recurring'
    | '/app/org/$orgId/financial/reports'
    | '/app/org/$orgId/financial/transactions'
    | '/app/org/$orgId/financial/vendors'
    | '/app/org/$orgId/grass-production/cultivars'
    | '/app/org/$orgId/livestock/$establishmentId'
    | '/app/org/$orgId/marketplace/incoming-requests'
    | '/app/org/$orgId/marketplace/my-offers'
    | '/app/org/$orgId/marketplace/my-requests'
    | '/app/org/$orgId/planning/objectives'
    | '/app/org/$orgId/planning/tasks'
    | '/app/org/$orgId/settings/ai-keys'
    | '/app/org/$orgId/settings/establishments'
    | '/app/org/$orgId/settings/financial'
    | '/app/org/$orgId/settings/livestock'
    | '/app/org/$orgId/settings/platform-plan'
    | '/app/org/$orgId/equipment/fleet/$equipmentId/edit'
    | '/app/org/$orgId/equipment/fleet/$equipmentId/inspect'
    | '/app/org/$orgId/equipment/parts/$partId/edit'
    | '/app/org/$orgId/grass-production/cultivars/$cultivarId/edit'
    | '/app/org/$orgId/livestock/$establishmentId/animals/import'
    | '/app/org/$orgId/livestock/$establishmentId/animals/new'
    | '/app/org/$orgId/livestock/$establishmentId/herds/new'
    | '/app/org/$orgId/marketplace/my-offers/$offerId/edit'
    | '/app/org/$orgId/equipment/fleet/$equipmentId'
    | '/app/org/$orgId/equipment/parts/$partId'
    | '/app/org/$orgId/financial/loans/$loanId'
    | '/app/org/$orgId/financial/payroll/labor'
    | '/app/org/$orgId/financial/payroll/workers'
    | '/app/org/$orgId/financial/recurring/$templateId'
    | '/app/org/$orgId/financial/transactions/$transactionId'
    | '/app/org/$orgId/grass-production/farms/$farmId'
    | '/app/org/$orgId/livestock/$establishmentId/registries'
    | '/app/org/$orgId/livestock/$establishmentId/weighing'
    | '/app/org/$orgId/planning/objectives/$objectiveId'
    | '/app/org/$orgId/planning/tasks/$taskId'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/soil-reports/import'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit'
    | '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit'
    | '/app/org/$orgId/financial/payroll/runs/$runId'
    | '/app/org/$orgId/grass-production/farms/$farmId/map'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId'
    | '/app/org/$orgId/livestock/$establishmentId/herds/$herdId'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new'
    | '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
    | '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/_public/'
    | '/_auth/app/_app'
    | '/_auth/app/select-organization'
    | '/_auth/staff-invite/$token'
    | '/_public/sign-in/$'
    | '/_public/sign-up/$'
    | '/_public/sign-in/'
    | '/_public/sign-up/'
    | '/_auth/app/_app/help'
    | '/_auth/app/_app/'
    | '/_auth/app/_app/help/support'
    | '/_auth/app/_app/help/user-guide'
    | '/_auth/app/_app/org/$orgId'
    | '/_auth/app/_app/org/renew-platform-plan'
    | '/_auth/app/_app/help/'
    | '/_auth/app/_app/user-settings/'
    | '/_auth/app/_app/org/$orgId/feasibility'
    | '/_auth/app/_app/org/$orgId/financial'
    | '/_auth/app/_app/org/$orgId/marketplace'
    | '/_auth/app/_app/org/$orgId/settings'
    | '/_auth/app/_app/org/$orgId/staff'
    | '/_auth/app/_app/help/user-guide/assistant'
    | '/_auth/app/_app/help/user-guide/equipment'
    | '/_auth/app/_app/help/user-guide/establishments'
    | '/_auth/app/_app/help/user-guide/feasibility'
    | '/_auth/app/_app/help/user-guide/financial'
    | '/_auth/app/_app/help/user-guide/grass-production'
    | '/_auth/app/_app/help/user-guide/livestock'
    | '/_auth/app/_app/help/user-guide/marketplace'
    | '/_auth/app/_app/help/user-guide/planning'
    | '/_auth/app/_app/org/$orgId/assistant'
    | '/_auth/app/_app/org/$orgId/equipment'
    | '/_auth/app/_app/org/$orgId/onboarding'
    | '/_auth/app/_app/org/$orgId/under_development'
    | '/_auth/app/_app/help/support/'
    | '/_auth/app/_app/help/user-guide/'
    | '/_auth/app/_app/org/$orgId/'
    | '/_auth/app/_app/help/support/tickets/$ticketId'
    | '/_auth/app/_app/org/$orgId/assistant/$conversationId'
    | '/_auth/app/_app/org/$orgId/feasibility/new'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId'
    | '/_auth/app/_app/org/$orgId/marketplace/$offerId'
    | '/_auth/app/_app/org/$orgId/staff/$staffId'
    | '/_auth/app/_app/help/support/tickets/'
    | '/_auth/app/_app/org/$orgId/assistant/'
    | '/_auth/app/_app/org/$orgId/equipment/'
    | '/_auth/app/_app/org/$orgId/establishments/'
    | '/_auth/app/_app/org/$orgId/feasibility/'
    | '/_auth/app/_app/org/$orgId/financial/'
    | '/_auth/app/_app/org/$orgId/grass-production/'
    | '/_auth/app/_app/org/$orgId/livestock/'
    | '/_auth/app/_app/org/$orgId/marketplace/'
    | '/_auth/app/_app/org/$orgId/mcp/'
    | '/_auth/app/_app/org/$orgId/offline-center/'
    | '/_auth/app/_app/org/$orgId/pending-actions/'
    | '/_auth/app/_app/org/$orgId/planning/'
    | '/_auth/app/_app/org/$orgId/settings/'
    | '/_auth/app/_app/org/$orgId/staff/'
    | '/_auth/app/_app/org/$orgId/equipment/breakdown-report/$reportId'
    | '/_auth/app/_app/org/$orgId/equipment/fleet/new'
    | '/_auth/app/_app/org/$orgId/equipment/parts/new'
    | '/_auth/app/_app/org/$orgId/financial/loans/new'
    | '/_auth/app/_app/org/$orgId/financial/payables/$billId'
    | '/_auth/app/_app/org/$orgId/financial/payables/new'
    | '/_auth/app/_app/org/$orgId/financial/receivables/$receivableId'
    | '/_auth/app/_app/org/$orgId/financial/recurring/new'
    | '/_auth/app/_app/org/$orgId/financial/transactions/import'
    | '/_auth/app/_app/org/$orgId/financial/transactions/new'
    | '/_auth/app/_app/org/$orgId/grass-production/cultivars/new'
    | '/_auth/app/_app/org/$orgId/marketplace/my-offers/new'
    | '/_auth/app/_app/org/$orgId/planning/tasks/calendar'
    | '/_auth/app/_app/org/$orgId/planning/tasks/kanban'
    | '/_auth/app/_app/org/$orgId/settings/platform-plan/success'
    | '/_auth/app/_app/org/$orgId/settings/platform-plan/update'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/edit'
    | '/_auth/app/_app/org/$orgId/staff/$staffId/permissions'
    | '/_auth/app/_app/org/$orgId/equipment/breakdown-report/'
    | '/_auth/app/_app/org/$orgId/equipment/fleet/'
    | '/_auth/app/_app/org/$orgId/equipment/parts/'
    | '/_auth/app/_app/org/$orgId/equipment/schedule/'
    | '/_auth/app/_app/org/$orgId/feasibility/$studyId/'
    | '/_auth/app/_app/org/$orgId/financial/loans/'
    | '/_auth/app/_app/org/$orgId/financial/payables/'
    | '/_auth/app/_app/org/$orgId/financial/payroll/'
    | '/_auth/app/_app/org/$orgId/financial/receivables/'
    | '/_auth/app/_app/org/$orgId/financial/recurring/'
    | '/_auth/app/_app/org/$orgId/financial/reports/'
    | '/_auth/app/_app/org/$orgId/financial/transactions/'
    | '/_auth/app/_app/org/$orgId/financial/vendors/'
    | '/_auth/app/_app/org/$orgId/grass-production/cultivars/'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/'
    | '/_auth/app/_app/org/$orgId/marketplace/incoming-requests/'
    | '/_auth/app/_app/org/$orgId/marketplace/my-offers/'
    | '/_auth/app/_app/org/$orgId/marketplace/my-requests/'
    | '/_auth/app/_app/org/$orgId/planning/objectives/'
    | '/_auth/app/_app/org/$orgId/planning/tasks/'
    | '/_auth/app/_app/org/$orgId/settings/ai-keys/'
    | '/_auth/app/_app/org/$orgId/settings/establishments/'
    | '/_auth/app/_app/org/$orgId/settings/financial/'
    | '/_auth/app/_app/org/$orgId/settings/livestock/'
    | '/_auth/app/_app/org/$orgId/settings/platform-plan/'
    | '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/edit'
    | '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/inspect'
    | '/_auth/app/_app/org/$orgId/equipment/parts/$partId/edit'
    | '/_auth/app/_app/org/$orgId/grass-production/cultivars/$cultivarId/edit'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/import'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/new'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/new'
    | '/_auth/app/_app/org/$orgId/marketplace/my-offers/$offerId/edit'
    | '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/'
    | '/_auth/app/_app/org/$orgId/equipment/parts/$partId/'
    | '/_auth/app/_app/org/$orgId/financial/loans/$loanId/'
    | '/_auth/app/_app/org/$orgId/financial/payroll/labor/'
    | '/_auth/app/_app/org/$orgId/financial/payroll/workers/'
    | '/_auth/app/_app/org/$orgId/financial/recurring/$templateId/'
    | '/_auth/app/_app/org/$orgId/financial/transactions/$transactionId/'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/registries/'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/weighing/'
    | '/_auth/app/_app/org/$orgId/planning/objectives/$objectiveId/'
    | '/_auth/app/_app/org/$orgId/planning/tasks/$taskId/'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/new'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/soil-reports/import'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit'
    | '/_auth/app/_app/org/$orgId/financial/payroll/runs/$runId/'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/map/'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new'
    | '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
    | '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up/': {
      id: '/_public/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof PublicSignUpIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/': {
      id: '/_public/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof PublicSignInIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up/$': {
      id: '/_public/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof PublicSignUpSplatRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/$': {
      id: '/_public/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof PublicSignInSplatRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/staff-invite/$token': {
      id: '/_auth/staff-invite/$token'
      path: '/staff-invite/$token'
      fullPath: '/staff-invite/$token'
      preLoaderRoute: typeof AuthStaffInviteTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/select-organization': {
      id: '/_auth/app/select-organization'
      path: '/app/select-organization'
      fullPath: '/app/select-organization'
      preLoaderRoute: typeof AuthAppSelectOrganizationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app': {
      id: '/_auth/app/_app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthAppAppRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/_app/': {
      id: '/_auth/app/_app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AuthAppAppIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/help': {
      id: '/_auth/app/_app/help'
      path: '/help'
      fullPath: '/app/help'
      preLoaderRoute: typeof AuthAppAppHelpRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/user-settings/': {
      id: '/_auth/app/_app/user-settings/'
      path: '/user-settings'
      fullPath: '/app/user-settings/'
      preLoaderRoute: typeof AuthAppAppUserSettingsIndexRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/help/': {
      id: '/_auth/app/_app/help/'
      path: '/'
      fullPath: '/app/help/'
      preLoaderRoute: typeof AuthAppAppHelpIndexRouteImport
      parentRoute: typeof AuthAppAppHelpRoute
    }
    '/_auth/app/_app/org/renew-platform-plan': {
      id: '/_auth/app/_app/org/renew-platform-plan'
      path: '/org/renew-platform-plan'
      fullPath: '/app/org/renew-platform-plan'
      preLoaderRoute: typeof AuthAppAppOrgRenewPlatformPlanRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/org/$orgId': {
      id: '/_auth/app/_app/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/app/org/$orgId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdRouteImport
      parentRoute: typeof AuthAppAppRoute
    }
    '/_auth/app/_app/help/user-guide': {
      id: '/_auth/app/_app/help/user-guide'
      path: '/user-guide'
      fullPath: '/app/help/user-guide'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideRouteImport
      parentRoute: typeof AuthAppAppHelpRoute
    }
    '/_auth/app/_app/help/support': {
      id: '/_auth/app/_app/help/support'
      path: '/support'
      fullPath: '/app/help/support'
      preLoaderRoute: typeof AuthAppAppHelpSupportRouteImport
      parentRoute: typeof AuthAppAppHelpRoute
    }
    '/_auth/app/_app/org/$orgId/': {
      id: '/_auth/app/_app/org/$orgId/'
      path: '/'
      fullPath: '/app/org/$orgId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/help/user-guide/': {
      id: '/_auth/app/_app/help/user-guide/'
      path: '/'
      fullPath: '/app/help/user-guide/'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideIndexRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/support/': {
      id: '/_auth/app/_app/help/support/'
      path: '/'
      fullPath: '/app/help/support/'
      preLoaderRoute: typeof AuthAppAppHelpSupportIndexRouteImport
      parentRoute: typeof AuthAppAppHelpSupportRoute
    }
    '/_auth/app/_app/org/$orgId/under_development': {
      id: '/_auth/app/_app/org/$orgId/under_development'
      path: '/under_development'
      fullPath: '/app/org/$orgId/under_development'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdUnder_developmentRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/onboarding': {
      id: '/_auth/app/_app/org/$orgId/onboarding'
      path: '/onboarding'
      fullPath: '/app/org/$orgId/onboarding'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOnboardingRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/equipment': {
      id: '/_auth/app/_app/org/$orgId/equipment'
      path: '/equipment'
      fullPath: '/app/org/$orgId/equipment'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/assistant': {
      id: '/_auth/app/_app/org/$orgId/assistant'
      path: '/assistant'
      fullPath: '/app/org/$orgId/assistant'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAssistantRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/help/user-guide/planning': {
      id: '/_auth/app/_app/help/user-guide/planning'
      path: '/planning'
      fullPath: '/app/help/user-guide/planning'
      preLoaderRoute: typeof AuthAppAppHelpUserGuidePlanningRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/marketplace': {
      id: '/_auth/app/_app/help/user-guide/marketplace'
      path: '/marketplace'
      fullPath: '/app/help/user-guide/marketplace'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideMarketplaceRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/livestock': {
      id: '/_auth/app/_app/help/user-guide/livestock'
      path: '/livestock'
      fullPath: '/app/help/user-guide/livestock'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideLivestockRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/grass-production': {
      id: '/_auth/app/_app/help/user-guide/grass-production'
      path: '/grass-production'
      fullPath: '/app/help/user-guide/grass-production'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideGrassProductionRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/financial': {
      id: '/_auth/app/_app/help/user-guide/financial'
      path: '/financial'
      fullPath: '/app/help/user-guide/financial'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideFinancialRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/feasibility': {
      id: '/_auth/app/_app/help/user-guide/feasibility'
      path: '/feasibility'
      fullPath: '/app/help/user-guide/feasibility'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideFeasibilityRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/establishments': {
      id: '/_auth/app/_app/help/user-guide/establishments'
      path: '/establishments'
      fullPath: '/app/help/user-guide/establishments'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideEstablishmentsRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/equipment': {
      id: '/_auth/app/_app/help/user-guide/equipment'
      path: '/equipment'
      fullPath: '/app/help/user-guide/equipment'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideEquipmentRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/help/user-guide/assistant': {
      id: '/_auth/app/_app/help/user-guide/assistant'
      path: '/assistant'
      fullPath: '/app/help/user-guide/assistant'
      preLoaderRoute: typeof AuthAppAppHelpUserGuideAssistantRouteImport
      parentRoute: typeof AuthAppAppHelpUserGuideRoute
    }
    '/_auth/app/_app/org/$orgId/staff': {
      id: '/_auth/app/_app/org/$orgId/staff'
      path: '/staff'
      fullPath: '/app/org/$orgId/staff'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffRouteRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings': {
      id: '/_auth/app/_app/org/$orgId/settings'
      path: '/settings'
      fullPath: '/app/org/$orgId/settings'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace': {
      id: '/_auth/app/_app/org/$orgId/marketplace'
      path: '/marketplace'
      fullPath: '/app/org/$orgId/marketplace'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/financial': {
      id: '/_auth/app/_app/org/$orgId/financial'
      path: '/financial'
      fullPath: '/app/org/$orgId/financial'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/feasibility': {
      id: '/_auth/app/_app/org/$orgId/feasibility'
      path: '/feasibility'
      fullPath: '/app/org/$orgId/feasibility'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFeasibilityRouteRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/staff/': {
      id: '/_auth/app/_app/org/$orgId/staff/'
      path: '/'
      fullPath: '/app/org/$orgId/staff/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffRouteRoute
    }
    '/_auth/app/_app/org/$orgId/settings/': {
      id: '/_auth/app/_app/org/$orgId/settings/'
      path: '/'
      fullPath: '/app/org/$orgId/settings/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/planning/': {
      id: '/_auth/app/_app/org/$orgId/planning/'
      path: '/planning'
      fullPath: '/app/org/$orgId/planning/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/pending-actions/': {
      id: '/_auth/app/_app/org/$orgId/pending-actions/'
      path: '/pending-actions'
      fullPath: '/app/org/$orgId/pending-actions/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPendingActionsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/offline-center/': {
      id: '/_auth/app/_app/org/$orgId/offline-center/'
      path: '/offline-center'
      fullPath: '/app/org/$orgId/offline-center/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdOfflineCenterIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/mcp/': {
      id: '/_auth/app/_app/org/$orgId/mcp/'
      path: '/mcp'
      fullPath: '/app/org/$orgId/mcp/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMcpIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/': {
      id: '/_auth/app/_app/org/$orgId/marketplace/'
      path: '/'
      fullPath: '/app/org/$orgId/marketplace/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/': {
      id: '/_auth/app/_app/org/$orgId/livestock/'
      path: '/livestock'
      fullPath: '/app/org/$orgId/livestock/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/'
      path: '/grass-production'
      fullPath: '/app/org/$orgId/grass-production/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/financial/': {
      id: '/_auth/app/_app/org/$orgId/financial/'
      path: '/'
      fullPath: '/app/org/$orgId/financial/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/feasibility/': {
      id: '/_auth/app/_app/org/$orgId/feasibility/'
      path: '/'
      fullPath: '/app/org/$orgId/feasibility/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFeasibilityIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFeasibilityRouteRoute
    }
    '/_auth/app/_app/org/$orgId/establishments/': {
      id: '/_auth/app/_app/org/$orgId/establishments/'
      path: '/establishments'
      fullPath: '/app/org/$orgId/establishments/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEstablishmentsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/': {
      id: '/_auth/app/_app/org/$orgId/equipment/'
      path: '/'
      fullPath: '/app/org/$orgId/equipment/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/assistant/': {
      id: '/_auth/app/_app/org/$orgId/assistant/'
      path: '/'
      fullPath: '/app/org/$orgId/assistant/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAssistantIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAssistantRoute
    }
    '/_auth/app/_app/help/support/tickets/': {
      id: '/_auth/app/_app/help/support/tickets/'
      path: '/tickets'
      fullPath: '/app/help/support/tickets/'
      preLoaderRoute: typeof AuthAppAppHelpSupportTicketsIndexRouteImport
      parentRoute: typeof AuthAppAppHelpSupportRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId'
      path: '/$staffId'
      fullPath: '/app/org/$orgId/staff/$staffId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffRouteRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/$offerId': {
      id: '/_auth/app/_app/org/$orgId/marketplace/$offerId'
      path: '/$offerId'
      fullPath: '/app/org/$orgId/marketplace/$offerId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceOfferIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId'
      path: '/livestock/$establishmentId'
      fullPath: '/app/org/$orgId/livestock/$establishmentId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/feasibility/new': {
      id: '/_auth/app/_app/org/$orgId/feasibility/new'
      path: '/new'
      fullPath: '/app/org/$orgId/feasibility/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFeasibilityNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFeasibilityRouteRoute
    }
    '/_auth/app/_app/org/$orgId/assistant/$conversationId': {
      id: '/_auth/app/_app/org/$orgId/assistant/$conversationId'
      path: '/$conversationId'
      fullPath: '/app/org/$orgId/assistant/$conversationId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdAssistantConversationIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdAssistantRoute
    }
    '/_auth/app/_app/help/support/tickets/$ticketId': {
      id: '/_auth/app/_app/help/support/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/app/help/support/tickets/$ticketId'
      preLoaderRoute: typeof AuthAppAppHelpSupportTicketsTicketIdRouteImport
      parentRoute: typeof AuthAppAppHelpSupportRoute
    }
    '/_auth/app/_app/org/$orgId/settings/platform-plan/': {
      id: '/_auth/app/_app/org/$orgId/settings/platform-plan/'
      path: '/platform-plan'
      fullPath: '/app/org/$orgId/settings/platform-plan/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/settings/livestock/': {
      id: '/_auth/app/_app/org/$orgId/settings/livestock/'
      path: '/livestock'
      fullPath: '/app/org/$orgId/settings/livestock/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsLivestockIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/settings/financial/': {
      id: '/_auth/app/_app/org/$orgId/settings/financial/'
      path: '/financial'
      fullPath: '/app/org/$orgId/settings/financial/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsFinancialIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/settings/establishments/': {
      id: '/_auth/app/_app/org/$orgId/settings/establishments/'
      path: '/establishments'
      fullPath: '/app/org/$orgId/settings/establishments/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/settings/ai-keys/': {
      id: '/_auth/app/_app/org/$orgId/settings/ai-keys/'
      path: '/ai-keys'
      fullPath: '/app/org/$orgId/settings/ai-keys/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsAiKeysIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/planning/tasks/': {
      id: '/_auth/app/_app/org/$orgId/planning/tasks/'
      path: '/planning/tasks'
      fullPath: '/app/org/$orgId/planning/tasks/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningTasksIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/planning/objectives/': {
      id: '/_auth/app/_app/org/$orgId/planning/objectives/'
      path: '/planning/objectives'
      fullPath: '/app/org/$orgId/planning/objectives/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningObjectivesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/my-requests/': {
      id: '/_auth/app/_app/org/$orgId/marketplace/my-requests/'
      path: '/my-requests'
      fullPath: '/app/org/$orgId/marketplace/my-requests/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/my-offers/': {
      id: '/_auth/app/_app/org/$orgId/marketplace/my-offers/'
      path: '/my-offers'
      fullPath: '/app/org/$orgId/marketplace/my-offers/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/incoming-requests/': {
      id: '/_auth/app/_app/org/$orgId/marketplace/incoming-requests/'
      path: '/incoming-requests'
      fullPath: '/app/org/$orgId/marketplace/incoming-requests/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/'
      path: '/'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/cultivars/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/cultivars/'
      path: '/grass-production/cultivars'
      fullPath: '/app/org/$orgId/grass-production/cultivars/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/financial/vendors/': {
      id: '/_auth/app/_app/org/$orgId/financial/vendors/'
      path: '/vendors'
      fullPath: '/app/org/$orgId/financial/vendors/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialVendorsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/transactions/': {
      id: '/_auth/app/_app/org/$orgId/financial/transactions/'
      path: '/transactions'
      fullPath: '/app/org/$orgId/financial/transactions/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/reports/': {
      id: '/_auth/app/_app/org/$orgId/financial/reports/'
      path: '/reports'
      fullPath: '/app/org/$orgId/financial/reports/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialReportsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/recurring/': {
      id: '/_auth/app/_app/org/$orgId/financial/recurring/'
      path: '/recurring'
      fullPath: '/app/org/$orgId/financial/recurring/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialRecurringIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/receivables/': {
      id: '/_auth/app/_app/org/$orgId/financial/receivables/'
      path: '/receivables'
      fullPath: '/app/org/$orgId/financial/receivables/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialReceivablesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payroll/': {
      id: '/_auth/app/_app/org/$orgId/financial/payroll/'
      path: '/payroll'
      fullPath: '/app/org/$orgId/financial/payroll/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payables/': {
      id: '/_auth/app/_app/org/$orgId/financial/payables/'
      path: '/payables'
      fullPath: '/app/org/$orgId/financial/payables/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayablesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/loans/': {
      id: '/_auth/app/_app/org/$orgId/financial/loans/'
      path: '/loans'
      fullPath: '/app/org/$orgId/financial/loans/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialLoansIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/feasibility/$studyId/': {
      id: '/_auth/app/_app/org/$orgId/feasibility/$studyId/'
      path: '/$studyId'
      fullPath: '/app/org/$orgId/feasibility/$studyId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFeasibilityRouteRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/schedule/': {
      id: '/_auth/app/_app/org/$orgId/equipment/schedule/'
      path: '/schedule'
      fullPath: '/app/org/$orgId/equipment/schedule/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentScheduleIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/parts/': {
      id: '/_auth/app/_app/org/$orgId/equipment/parts/'
      path: '/parts'
      fullPath: '/app/org/$orgId/equipment/parts/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/fleet/': {
      id: '/_auth/app/_app/org/$orgId/equipment/fleet/'
      path: '/fleet'
      fullPath: '/app/org/$orgId/equipment/fleet/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/breakdown-report/': {
      id: '/_auth/app/_app/org/$orgId/equipment/breakdown-report/'
      path: '/breakdown-report'
      fullPath: '/app/org/$orgId/equipment/breakdown-report/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/permissions': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/permissions'
      path: '/permissions'
      fullPath: '/app/org/$orgId/staff/$staffId/permissions'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/staff/$staffId/edit': {
      id: '/_auth/app/_app/org/$orgId/staff/$staffId/edit'
      path: '/edit'
      fullPath: '/app/org/$orgId/staff/$staffId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRoute
    }
    '/_auth/app/_app/org/$orgId/settings/platform-plan/update': {
      id: '/_auth/app/_app/org/$orgId/settings/platform-plan/update'
      path: '/platform-plan/update'
      fullPath: '/app/org/$orgId/settings/platform-plan/update'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/settings/platform-plan/success': {
      id: '/_auth/app/_app/org/$orgId/settings/platform-plan/success'
      path: '/platform-plan/success'
      fullPath: '/app/org/$orgId/settings/platform-plan/success'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRoute
    }
    '/_auth/app/_app/org/$orgId/planning/tasks/kanban': {
      id: '/_auth/app/_app/org/$orgId/planning/tasks/kanban'
      path: '/planning/tasks/kanban'
      fullPath: '/app/org/$orgId/planning/tasks/kanban'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningTasksKanbanRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/planning/tasks/calendar': {
      id: '/_auth/app/_app/org/$orgId/planning/tasks/calendar'
      path: '/planning/tasks/calendar'
      fullPath: '/app/org/$orgId/planning/tasks/calendar'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningTasksCalendarRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/my-offers/new': {
      id: '/_auth/app/_app/org/$orgId/marketplace/my-offers/new'
      path: '/my-offers/new'
      fullPath: '/app/org/$orgId/marketplace/my-offers/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyOffersNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/cultivars/new': {
      id: '/_auth/app/_app/org/$orgId/grass-production/cultivars/new'
      path: '/grass-production/cultivars/new'
      fullPath: '/app/org/$orgId/grass-production/cultivars/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionCultivarsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/financial/transactions/new': {
      id: '/_auth/app/_app/org/$orgId/financial/transactions/new'
      path: '/transactions/new'
      fullPath: '/app/org/$orgId/financial/transactions/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/transactions/import': {
      id: '/_auth/app/_app/org/$orgId/financial/transactions/import'
      path: '/transactions/import'
      fullPath: '/app/org/$orgId/financial/transactions/import'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsImportRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/recurring/new': {
      id: '/_auth/app/_app/org/$orgId/financial/recurring/new'
      path: '/recurring/new'
      fullPath: '/app/org/$orgId/financial/recurring/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialRecurringNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/receivables/$receivableId': {
      id: '/_auth/app/_app/org/$orgId/financial/receivables/$receivableId'
      path: '/receivables/$receivableId'
      fullPath: '/app/org/$orgId/financial/receivables/$receivableId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payables/new': {
      id: '/_auth/app/_app/org/$orgId/financial/payables/new'
      path: '/payables/new'
      fullPath: '/app/org/$orgId/financial/payables/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayablesNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payables/$billId': {
      id: '/_auth/app/_app/org/$orgId/financial/payables/$billId'
      path: '/payables/$billId'
      fullPath: '/app/org/$orgId/financial/payables/$billId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayablesBillIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/loans/new': {
      id: '/_auth/app/_app/org/$orgId/financial/loans/new'
      path: '/loans/new'
      fullPath: '/app/org/$orgId/financial/loans/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialLoansNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/parts/new': {
      id: '/_auth/app/_app/org/$orgId/equipment/parts/new'
      path: '/parts/new'
      fullPath: '/app/org/$orgId/equipment/parts/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/fleet/new': {
      id: '/_auth/app/_app/org/$orgId/equipment/fleet/new'
      path: '/fleet/new'
      fullPath: '/app/org/$orgId/equipment/fleet/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/breakdown-report/$reportId': {
      id: '/_auth/app/_app/org/$orgId/equipment/breakdown-report/$reportId'
      path: '/breakdown-report/$reportId'
      fullPath: '/app/org/$orgId/equipment/breakdown-report/$reportId'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/planning/tasks/$taskId/': {
      id: '/_auth/app/_app/org/$orgId/planning/tasks/$taskId/'
      path: '/planning/tasks/$taskId'
      fullPath: '/app/org/$orgId/planning/tasks/$taskId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/planning/objectives/$objectiveId/': {
      id: '/_auth/app/_app/org/$orgId/planning/objectives/$objectiveId/'
      path: '/planning/objectives/$objectiveId'
      fullPath: '/app/org/$orgId/planning/objectives/$objectiveId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/weighing/': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/weighing/'
      path: '/weighing'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/weighing/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/registries/': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/registries/'
      path: '/registries'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/registries/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/'
      path: '/grass-production/farms/$farmId'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/financial/transactions/$transactionId/': {
      id: '/_auth/app/_app/org/$orgId/financial/transactions/$transactionId/'
      path: '/transactions/$transactionId'
      fullPath: '/app/org/$orgId/financial/transactions/$transactionId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/recurring/$templateId/': {
      id: '/_auth/app/_app/org/$orgId/financial/recurring/$templateId/'
      path: '/recurring/$templateId'
      fullPath: '/app/org/$orgId/financial/recurring/$templateId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payroll/workers/': {
      id: '/_auth/app/_app/org/$orgId/financial/payroll/workers/'
      path: '/payroll/workers'
      fullPath: '/app/org/$orgId/financial/payroll/workers/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payroll/labor/': {
      id: '/_auth/app/_app/org/$orgId/financial/payroll/labor/'
      path: '/payroll/labor'
      fullPath: '/app/org/$orgId/financial/payroll/labor/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/financial/loans/$loanId/': {
      id: '/_auth/app/_app/org/$orgId/financial/loans/$loanId/'
      path: '/loans/$loanId'
      fullPath: '/app/org/$orgId/financial/loans/$loanId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/parts/$partId/': {
      id: '/_auth/app/_app/org/$orgId/equipment/parts/$partId/'
      path: '/parts/$partId'
      fullPath: '/app/org/$orgId/equipment/parts/$partId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/': {
      id: '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/'
      path: '/fleet/$equipmentId'
      fullPath: '/app/org/$orgId/equipment/fleet/$equipmentId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/marketplace/my-offers/$offerId/edit': {
      id: '/_auth/app/_app/org/$orgId/marketplace/my-offers/$offerId/edit'
      path: '/my-offers/$offerId/edit'
      fullPath: '/app/org/$orgId/marketplace/my-offers/$offerId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/new': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/new'
      path: '/herds/new'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/herds/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/new': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/new'
      path: '/animals/new'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/animals/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/import': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/import'
      path: '/animals/import'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/animals/import'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/cultivars/$cultivarId/edit': {
      id: '/_auth/app/_app/org/$orgId/grass-production/cultivars/$cultivarId/edit'
      path: '/grass-production/cultivars/$cultivarId/edit'
      fullPath: '/app/org/$orgId/grass-production/cultivars/$cultivarId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/parts/$partId/edit': {
      id: '/_auth/app/_app/org/$orgId/equipment/parts/$partId/edit'
      path: '/parts/$partId/edit'
      fullPath: '/app/org/$orgId/equipment/parts/$partId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/inspect': {
      id: '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/inspect'
      path: '/fleet/$equipmentId/inspect'
      fullPath: '/app/org/$orgId/equipment/fleet/$equipmentId/inspect'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/edit': {
      id: '/_auth/app/_app/org/$orgId/equipment/fleet/$equipmentId/edit'
      path: '/fleet/$equipmentId/edit'
      fullPath: '/app/org/$orgId/equipment/fleet/$equipmentId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdEquipmentRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/'
      path: '/herds/$herdId'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/'
      path: '/animals/$animalId'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/'
      path: '/grass-production/farms/$farmId/paddocks'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/map/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/map/'
      path: '/grass-production/farms/$farmId/map'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/map/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/financial/payroll/runs/$runId/': {
      id: '/_auth/app/_app/org/$orgId/financial/payroll/runs/$runId/'
      path: '/payroll/runs/$runId'
      fullPath: '/app/org/$orgId/financial/payroll/runs/$runId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit'
      path: '/herds/$herdId/edit'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/herds/$herdId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit'
      path: '/animals/$animalId/edit'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/soil-reports/import': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/soil-reports/import'
      path: '/grass-production/farms/$farmId/soil-reports/import'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/soil-reports/import'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/new': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/new'
      path: '/grass-production/farms/$farmId/paddocks/new'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/'
      path: '/grass-production/farms/$farmId/paddocks/$paddockId'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new'
      path: '/animals/$animalId/operations/new'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/operations/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new': {
      id: '/_auth/app/_app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new'
      path: '/animals/$animalId/measurements/new'
      fullPath: '/app/org/$orgId/livestock/$establishmentId/animals/$animalId/measurements/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit'
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/edit'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/edit'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/operations/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/measurements/new'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
    '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/': {
      id: '/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/'
      path: '/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId'
      fullPath: '/app/org/$orgId/grass-production/farms/$farmId/paddocks/$paddockId/soil-analyses/$analysisId/'
      preLoaderRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRouteImport
      parentRoute: typeof AuthAppAppOrgOrgIdRoute
    }
  }
}

interface AuthAppAppHelpSupportRouteChildren {
  AuthAppAppHelpSupportIndexRoute: typeof AuthAppAppHelpSupportIndexRoute
  AuthAppAppHelpSupportTicketsTicketIdRoute: typeof AuthAppAppHelpSupportTicketsTicketIdRoute
  AuthAppAppHelpSupportTicketsIndexRoute: typeof AuthAppAppHelpSupportTicketsIndexRoute
}

const AuthAppAppHelpSupportRouteChildren: AuthAppAppHelpSupportRouteChildren = {
  AuthAppAppHelpSupportIndexRoute: AuthAppAppHelpSupportIndexRoute,
  AuthAppAppHelpSupportTicketsTicketIdRoute:
    AuthAppAppHelpSupportTicketsTicketIdRoute,
  AuthAppAppHelpSupportTicketsIndexRoute:
    AuthAppAppHelpSupportTicketsIndexRoute,
}

const AuthAppAppHelpSupportRouteWithChildren =
  AuthAppAppHelpSupportRoute._addFileChildren(
    AuthAppAppHelpSupportRouteChildren,
  )

interface AuthAppAppHelpUserGuideRouteChildren {
  AuthAppAppHelpUserGuideAssistantRoute: typeof AuthAppAppHelpUserGuideAssistantRoute
  AuthAppAppHelpUserGuideEquipmentRoute: typeof AuthAppAppHelpUserGuideEquipmentRoute
  AuthAppAppHelpUserGuideEstablishmentsRoute: typeof AuthAppAppHelpUserGuideEstablishmentsRoute
  AuthAppAppHelpUserGuideFeasibilityRoute: typeof AuthAppAppHelpUserGuideFeasibilityRoute
  AuthAppAppHelpUserGuideFinancialRoute: typeof AuthAppAppHelpUserGuideFinancialRoute
  AuthAppAppHelpUserGuideGrassProductionRoute: typeof AuthAppAppHelpUserGuideGrassProductionRoute
  AuthAppAppHelpUserGuideLivestockRoute: typeof AuthAppAppHelpUserGuideLivestockRoute
  AuthAppAppHelpUserGuideMarketplaceRoute: typeof AuthAppAppHelpUserGuideMarketplaceRoute
  AuthAppAppHelpUserGuidePlanningRoute: typeof AuthAppAppHelpUserGuidePlanningRoute
  AuthAppAppHelpUserGuideIndexRoute: typeof AuthAppAppHelpUserGuideIndexRoute
}

const AuthAppAppHelpUserGuideRouteChildren: AuthAppAppHelpUserGuideRouteChildren =
  {
    AuthAppAppHelpUserGuideAssistantRoute:
      AuthAppAppHelpUserGuideAssistantRoute,
    AuthAppAppHelpUserGuideEquipmentRoute:
      AuthAppAppHelpUserGuideEquipmentRoute,
    AuthAppAppHelpUserGuideEstablishmentsRoute:
      AuthAppAppHelpUserGuideEstablishmentsRoute,
    AuthAppAppHelpUserGuideFeasibilityRoute:
      AuthAppAppHelpUserGuideFeasibilityRoute,
    AuthAppAppHelpUserGuideFinancialRoute:
      AuthAppAppHelpUserGuideFinancialRoute,
    AuthAppAppHelpUserGuideGrassProductionRoute:
      AuthAppAppHelpUserGuideGrassProductionRoute,
    AuthAppAppHelpUserGuideLivestockRoute:
      AuthAppAppHelpUserGuideLivestockRoute,
    AuthAppAppHelpUserGuideMarketplaceRoute:
      AuthAppAppHelpUserGuideMarketplaceRoute,
    AuthAppAppHelpUserGuidePlanningRoute: AuthAppAppHelpUserGuidePlanningRoute,
    AuthAppAppHelpUserGuideIndexRoute: AuthAppAppHelpUserGuideIndexRoute,
  }

const AuthAppAppHelpUserGuideRouteWithChildren =
  AuthAppAppHelpUserGuideRoute._addFileChildren(
    AuthAppAppHelpUserGuideRouteChildren,
  )

interface AuthAppAppHelpRouteChildren {
  AuthAppAppHelpSupportRoute: typeof AuthAppAppHelpSupportRouteWithChildren
  AuthAppAppHelpUserGuideRoute: typeof AuthAppAppHelpUserGuideRouteWithChildren
  AuthAppAppHelpIndexRoute: typeof AuthAppAppHelpIndexRoute
}

const AuthAppAppHelpRouteChildren: AuthAppAppHelpRouteChildren = {
  AuthAppAppHelpSupportRoute: AuthAppAppHelpSupportRouteWithChildren,
  AuthAppAppHelpUserGuideRoute: AuthAppAppHelpUserGuideRouteWithChildren,
  AuthAppAppHelpIndexRoute: AuthAppAppHelpIndexRoute,
}

const AuthAppAppHelpRouteWithChildren = AuthAppAppHelpRoute._addFileChildren(
  AuthAppAppHelpRouteChildren,
)

interface AuthAppAppOrgOrgIdFeasibilityRouteRouteChildren {
  AuthAppAppOrgOrgIdFeasibilityNewRoute: typeof AuthAppAppOrgOrgIdFeasibilityNewRoute
  AuthAppAppOrgOrgIdFeasibilityIndexRoute: typeof AuthAppAppOrgOrgIdFeasibilityIndexRoute
  AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute: typeof AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute
}

const AuthAppAppOrgOrgIdFeasibilityRouteRouteChildren: AuthAppAppOrgOrgIdFeasibilityRouteRouteChildren =
  {
    AuthAppAppOrgOrgIdFeasibilityNewRoute:
      AuthAppAppOrgOrgIdFeasibilityNewRoute,
    AuthAppAppOrgOrgIdFeasibilityIndexRoute:
      AuthAppAppOrgOrgIdFeasibilityIndexRoute,
    AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute:
      AuthAppAppOrgOrgIdFeasibilityStudyIdIndexRoute,
  }

const AuthAppAppOrgOrgIdFeasibilityRouteRouteWithChildren =
  AuthAppAppOrgOrgIdFeasibilityRouteRoute._addFileChildren(
    AuthAppAppOrgOrgIdFeasibilityRouteRouteChildren,
  )

interface AuthAppAppOrgOrgIdFinancialRouteRouteChildren {
  AuthAppAppOrgOrgIdFinancialIndexRoute: typeof AuthAppAppOrgOrgIdFinancialIndexRoute
  AuthAppAppOrgOrgIdFinancialLoansNewRoute: typeof AuthAppAppOrgOrgIdFinancialLoansNewRoute
  AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute: typeof AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute
  AuthAppAppOrgOrgIdFinancialPayablesNewRoute: typeof AuthAppAppOrgOrgIdFinancialPayablesNewRoute
  AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute: typeof AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute
  AuthAppAppOrgOrgIdFinancialRecurringNewRoute: typeof AuthAppAppOrgOrgIdFinancialRecurringNewRoute
  AuthAppAppOrgOrgIdFinancialTransactionsImportRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsImportRoute
  AuthAppAppOrgOrgIdFinancialTransactionsNewRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsNewRoute
  AuthAppAppOrgOrgIdFinancialLoansIndexRoute: typeof AuthAppAppOrgOrgIdFinancialLoansIndexRoute
  AuthAppAppOrgOrgIdFinancialPayablesIndexRoute: typeof AuthAppAppOrgOrgIdFinancialPayablesIndexRoute
  AuthAppAppOrgOrgIdFinancialPayrollIndexRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollIndexRoute
  AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute: typeof AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute
  AuthAppAppOrgOrgIdFinancialRecurringIndexRoute: typeof AuthAppAppOrgOrgIdFinancialRecurringIndexRoute
  AuthAppAppOrgOrgIdFinancialReportsIndexRoute: typeof AuthAppAppOrgOrgIdFinancialReportsIndexRoute
  AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute
  AuthAppAppOrgOrgIdFinancialVendorsIndexRoute: typeof AuthAppAppOrgOrgIdFinancialVendorsIndexRoute
  AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute: typeof AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute
  AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute
  AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute
  AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute: typeof AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute
  AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute: typeof AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute
  AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute: typeof AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute
}

const AuthAppAppOrgOrgIdFinancialRouteRouteChildren: AuthAppAppOrgOrgIdFinancialRouteRouteChildren =
  {
    AuthAppAppOrgOrgIdFinancialIndexRoute:
      AuthAppAppOrgOrgIdFinancialIndexRoute,
    AuthAppAppOrgOrgIdFinancialLoansNewRoute:
      AuthAppAppOrgOrgIdFinancialLoansNewRoute,
    AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute:
      AuthAppAppOrgOrgIdFinancialPayablesBillIdRoute,
    AuthAppAppOrgOrgIdFinancialPayablesNewRoute:
      AuthAppAppOrgOrgIdFinancialPayablesNewRoute,
    AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute:
      AuthAppAppOrgOrgIdFinancialReceivablesReceivableIdRoute,
    AuthAppAppOrgOrgIdFinancialRecurringNewRoute:
      AuthAppAppOrgOrgIdFinancialRecurringNewRoute,
    AuthAppAppOrgOrgIdFinancialTransactionsImportRoute:
      AuthAppAppOrgOrgIdFinancialTransactionsImportRoute,
    AuthAppAppOrgOrgIdFinancialTransactionsNewRoute:
      AuthAppAppOrgOrgIdFinancialTransactionsNewRoute,
    AuthAppAppOrgOrgIdFinancialLoansIndexRoute:
      AuthAppAppOrgOrgIdFinancialLoansIndexRoute,
    AuthAppAppOrgOrgIdFinancialPayablesIndexRoute:
      AuthAppAppOrgOrgIdFinancialPayablesIndexRoute,
    AuthAppAppOrgOrgIdFinancialPayrollIndexRoute:
      AuthAppAppOrgOrgIdFinancialPayrollIndexRoute,
    AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute:
      AuthAppAppOrgOrgIdFinancialReceivablesIndexRoute,
    AuthAppAppOrgOrgIdFinancialRecurringIndexRoute:
      AuthAppAppOrgOrgIdFinancialRecurringIndexRoute,
    AuthAppAppOrgOrgIdFinancialReportsIndexRoute:
      AuthAppAppOrgOrgIdFinancialReportsIndexRoute,
    AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute:
      AuthAppAppOrgOrgIdFinancialTransactionsIndexRoute,
    AuthAppAppOrgOrgIdFinancialVendorsIndexRoute:
      AuthAppAppOrgOrgIdFinancialVendorsIndexRoute,
    AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute:
      AuthAppAppOrgOrgIdFinancialLoansLoanIdIndexRoute,
    AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute:
      AuthAppAppOrgOrgIdFinancialPayrollLaborIndexRoute,
    AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute:
      AuthAppAppOrgOrgIdFinancialPayrollWorkersIndexRoute,
    AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute:
      AuthAppAppOrgOrgIdFinancialRecurringTemplateIdIndexRoute,
    AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute:
      AuthAppAppOrgOrgIdFinancialTransactionsTransactionIdIndexRoute,
    AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute:
      AuthAppAppOrgOrgIdFinancialPayrollRunsRunIdIndexRoute,
  }

const AuthAppAppOrgOrgIdFinancialRouteRouteWithChildren =
  AuthAppAppOrgOrgIdFinancialRouteRoute._addFileChildren(
    AuthAppAppOrgOrgIdFinancialRouteRouteChildren,
  )

interface AuthAppAppOrgOrgIdMarketplaceRouteRouteChildren {
  AuthAppAppOrgOrgIdMarketplaceOfferIdRoute: typeof AuthAppAppOrgOrgIdMarketplaceOfferIdRoute
  AuthAppAppOrgOrgIdMarketplaceIndexRoute: typeof AuthAppAppOrgOrgIdMarketplaceIndexRoute
  AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute
  AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute: typeof AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute
  AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute
  AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute
  AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute: typeof AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute
}

const AuthAppAppOrgOrgIdMarketplaceRouteRouteChildren: AuthAppAppOrgOrgIdMarketplaceRouteRouteChildren =
  {
    AuthAppAppOrgOrgIdMarketplaceOfferIdRoute:
      AuthAppAppOrgOrgIdMarketplaceOfferIdRoute,
    AuthAppAppOrgOrgIdMarketplaceIndexRoute:
      AuthAppAppOrgOrgIdMarketplaceIndexRoute,
    AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute:
      AuthAppAppOrgOrgIdMarketplaceMyOffersNewRoute,
    AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute:
      AuthAppAppOrgOrgIdMarketplaceIncomingRequestsIndexRoute,
    AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute:
      AuthAppAppOrgOrgIdMarketplaceMyOffersIndexRoute,
    AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute:
      AuthAppAppOrgOrgIdMarketplaceMyRequestsIndexRoute,
    AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute:
      AuthAppAppOrgOrgIdMarketplaceMyOffersOfferIdEditRoute,
  }

const AuthAppAppOrgOrgIdMarketplaceRouteRouteWithChildren =
  AuthAppAppOrgOrgIdMarketplaceRouteRoute._addFileChildren(
    AuthAppAppOrgOrgIdMarketplaceRouteRouteChildren,
  )

interface AuthAppAppOrgOrgIdSettingsRouteRouteChildren {
  AuthAppAppOrgOrgIdSettingsIndexRoute: typeof AuthAppAppOrgOrgIdSettingsIndexRoute
  AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute: typeof AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute
  AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute: typeof AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute
  AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute: typeof AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute
  AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute: typeof AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute
  AuthAppAppOrgOrgIdSettingsFinancialIndexRoute: typeof AuthAppAppOrgOrgIdSettingsFinancialIndexRoute
  AuthAppAppOrgOrgIdSettingsLivestockIndexRoute: typeof AuthAppAppOrgOrgIdSettingsLivestockIndexRoute
  AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute: typeof AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute
}

const AuthAppAppOrgOrgIdSettingsRouteRouteChildren: AuthAppAppOrgOrgIdSettingsRouteRouteChildren =
  {
    AuthAppAppOrgOrgIdSettingsIndexRoute: AuthAppAppOrgOrgIdSettingsIndexRoute,
    AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute:
      AuthAppAppOrgOrgIdSettingsPlatformPlanSuccessRoute,
    AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute:
      AuthAppAppOrgOrgIdSettingsPlatformPlanUpdateRoute,
    AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute:
      AuthAppAppOrgOrgIdSettingsAiKeysIndexRoute,
    AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute:
      AuthAppAppOrgOrgIdSettingsEstablishmentsIndexRoute,
    AuthAppAppOrgOrgIdSettingsFinancialIndexRoute:
      AuthAppAppOrgOrgIdSettingsFinancialIndexRoute,
    AuthAppAppOrgOrgIdSettingsLivestockIndexRoute:
      AuthAppAppOrgOrgIdSettingsLivestockIndexRoute,
    AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute:
      AuthAppAppOrgOrgIdSettingsPlatformPlanIndexRoute,
  }

const AuthAppAppOrgOrgIdSettingsRouteRouteWithChildren =
  AuthAppAppOrgOrgIdSettingsRouteRoute._addFileChildren(
    AuthAppAppOrgOrgIdSettingsRouteRouteChildren,
  )

interface AuthAppAppOrgOrgIdStaffStaffIdRouteChildren {
  AuthAppAppOrgOrgIdStaffStaffIdEditRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdEditRoute
  AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute
}

const AuthAppAppOrgOrgIdStaffStaffIdRouteChildren: AuthAppAppOrgOrgIdStaffStaffIdRouteChildren =
  {
    AuthAppAppOrgOrgIdStaffStaffIdEditRoute:
      AuthAppAppOrgOrgIdStaffStaffIdEditRoute,
    AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute:
      AuthAppAppOrgOrgIdStaffStaffIdPermissionsRoute,
  }

const AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren =
  AuthAppAppOrgOrgIdStaffStaffIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdStaffStaffIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdStaffRouteRouteChildren {
  AuthAppAppOrgOrgIdStaffStaffIdRoute: typeof AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren
  AuthAppAppOrgOrgIdStaffIndexRoute: typeof AuthAppAppOrgOrgIdStaffIndexRoute
}

const AuthAppAppOrgOrgIdStaffRouteRouteChildren: AuthAppAppOrgOrgIdStaffRouteRouteChildren =
  {
    AuthAppAppOrgOrgIdStaffStaffIdRoute:
      AuthAppAppOrgOrgIdStaffStaffIdRouteWithChildren,
    AuthAppAppOrgOrgIdStaffIndexRoute: AuthAppAppOrgOrgIdStaffIndexRoute,
  }

const AuthAppAppOrgOrgIdStaffRouteRouteWithChildren =
  AuthAppAppOrgOrgIdStaffRouteRoute._addFileChildren(
    AuthAppAppOrgOrgIdStaffRouteRouteChildren,
  )

interface AuthAppAppOrgOrgIdAssistantRouteChildren {
  AuthAppAppOrgOrgIdAssistantConversationIdRoute: typeof AuthAppAppOrgOrgIdAssistantConversationIdRoute
  AuthAppAppOrgOrgIdAssistantIndexRoute: typeof AuthAppAppOrgOrgIdAssistantIndexRoute
}

const AuthAppAppOrgOrgIdAssistantRouteChildren: AuthAppAppOrgOrgIdAssistantRouteChildren =
  {
    AuthAppAppOrgOrgIdAssistantConversationIdRoute:
      AuthAppAppOrgOrgIdAssistantConversationIdRoute,
    AuthAppAppOrgOrgIdAssistantIndexRoute:
      AuthAppAppOrgOrgIdAssistantIndexRoute,
  }

const AuthAppAppOrgOrgIdAssistantRouteWithChildren =
  AuthAppAppOrgOrgIdAssistantRoute._addFileChildren(
    AuthAppAppOrgOrgIdAssistantRouteChildren,
  )

interface AuthAppAppOrgOrgIdEquipmentRouteChildren {
  AuthAppAppOrgOrgIdEquipmentIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentIndexRoute
  AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute: typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute
  AuthAppAppOrgOrgIdEquipmentFleetNewRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetNewRoute
  AuthAppAppOrgOrgIdEquipmentPartsNewRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsNewRoute
  AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute
  AuthAppAppOrgOrgIdEquipmentFleetIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetIndexRoute
  AuthAppAppOrgOrgIdEquipmentPartsIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsIndexRoute
  AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute
  AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute
  AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute
  AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute
  AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute
  AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute: typeof AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute
}

const AuthAppAppOrgOrgIdEquipmentRouteChildren: AuthAppAppOrgOrgIdEquipmentRouteChildren =
  {
    AuthAppAppOrgOrgIdEquipmentIndexRoute:
      AuthAppAppOrgOrgIdEquipmentIndexRoute,
    AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute:
      AuthAppAppOrgOrgIdEquipmentBreakdownReportReportIdRoute,
    AuthAppAppOrgOrgIdEquipmentFleetNewRoute:
      AuthAppAppOrgOrgIdEquipmentFleetNewRoute,
    AuthAppAppOrgOrgIdEquipmentPartsNewRoute:
      AuthAppAppOrgOrgIdEquipmentPartsNewRoute,
    AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute:
      AuthAppAppOrgOrgIdEquipmentBreakdownReportIndexRoute,
    AuthAppAppOrgOrgIdEquipmentFleetIndexRoute:
      AuthAppAppOrgOrgIdEquipmentFleetIndexRoute,
    AuthAppAppOrgOrgIdEquipmentPartsIndexRoute:
      AuthAppAppOrgOrgIdEquipmentPartsIndexRoute,
    AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute:
      AuthAppAppOrgOrgIdEquipmentScheduleIndexRoute,
    AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute:
      AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdEditRoute,
    AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute:
      AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdInspectRoute,
    AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute:
      AuthAppAppOrgOrgIdEquipmentPartsPartIdEditRoute,
    AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute:
      AuthAppAppOrgOrgIdEquipmentFleetEquipmentIdIndexRoute,
    AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute:
      AuthAppAppOrgOrgIdEquipmentPartsPartIdIndexRoute,
  }

const AuthAppAppOrgOrgIdEquipmentRouteWithChildren =
  AuthAppAppOrgOrgIdEquipmentRoute._addFileChildren(
    AuthAppAppOrgOrgIdEquipmentRouteChildren,
  )

interface AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteChildren {
  AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute
}

const AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteChildren: AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteChildren =
  {
    AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdIndexRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsImportRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsNewRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsNewRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdRegistriesIndexRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdWeighingIndexRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdEditRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdEditRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdIndexRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdHerdsHerdIdIndexRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdMeasurementsNewRoute,
    AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute:
      AuthAppAppOrgOrgIdLivestockEstablishmentIdAnimalsAnimalIdOperationsNewRoute,
  }

const AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteWithChildren =
  AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute._addFileChildren(
    AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteChildren,
  )

interface AuthAppAppOrgOrgIdRouteChildren {
  AuthAppAppOrgOrgIdFeasibilityRouteRoute: typeof AuthAppAppOrgOrgIdFeasibilityRouteRouteWithChildren
  AuthAppAppOrgOrgIdFinancialRouteRoute: typeof AuthAppAppOrgOrgIdFinancialRouteRouteWithChildren
  AuthAppAppOrgOrgIdMarketplaceRouteRoute: typeof AuthAppAppOrgOrgIdMarketplaceRouteRouteWithChildren
  AuthAppAppOrgOrgIdSettingsRouteRoute: typeof AuthAppAppOrgOrgIdSettingsRouteRouteWithChildren
  AuthAppAppOrgOrgIdStaffRouteRoute: typeof AuthAppAppOrgOrgIdStaffRouteRouteWithChildren
  AuthAppAppOrgOrgIdAssistantRoute: typeof AuthAppAppOrgOrgIdAssistantRouteWithChildren
  AuthAppAppOrgOrgIdEquipmentRoute: typeof AuthAppAppOrgOrgIdEquipmentRouteWithChildren
  AuthAppAppOrgOrgIdOnboardingRoute: typeof AuthAppAppOrgOrgIdOnboardingRoute
  AuthAppAppOrgOrgIdUnder_developmentRoute: typeof AuthAppAppOrgOrgIdUnder_developmentRoute
  AuthAppAppOrgOrgIdIndexRoute: typeof AuthAppAppOrgOrgIdIndexRoute
  AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute: typeof AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteWithChildren
  AuthAppAppOrgOrgIdEstablishmentsIndexRoute: typeof AuthAppAppOrgOrgIdEstablishmentsIndexRoute
  AuthAppAppOrgOrgIdGrassProductionIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionIndexRoute
  AuthAppAppOrgOrgIdLivestockIndexRoute: typeof AuthAppAppOrgOrgIdLivestockIndexRoute
  AuthAppAppOrgOrgIdMcpIndexRoute: typeof AuthAppAppOrgOrgIdMcpIndexRoute
  AuthAppAppOrgOrgIdOfflineCenterIndexRoute: typeof AuthAppAppOrgOrgIdOfflineCenterIndexRoute
  AuthAppAppOrgOrgIdPendingActionsIndexRoute: typeof AuthAppAppOrgOrgIdPendingActionsIndexRoute
  AuthAppAppOrgOrgIdPlanningIndexRoute: typeof AuthAppAppOrgOrgIdPlanningIndexRoute
  AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute: typeof AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute
  AuthAppAppOrgOrgIdPlanningTasksCalendarRoute: typeof AuthAppAppOrgOrgIdPlanningTasksCalendarRoute
  AuthAppAppOrgOrgIdPlanningTasksKanbanRoute: typeof AuthAppAppOrgOrgIdPlanningTasksKanbanRoute
  AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute
  AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute: typeof AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute
  AuthAppAppOrgOrgIdPlanningTasksIndexRoute: typeof AuthAppAppOrgOrgIdPlanningTasksIndexRoute
  AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute: typeof AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute
  AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute: typeof AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute
  AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute: typeof AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute: typeof AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute
}

const AuthAppAppOrgOrgIdRouteChildren: AuthAppAppOrgOrgIdRouteChildren = {
  AuthAppAppOrgOrgIdFeasibilityRouteRoute:
    AuthAppAppOrgOrgIdFeasibilityRouteRouteWithChildren,
  AuthAppAppOrgOrgIdFinancialRouteRoute:
    AuthAppAppOrgOrgIdFinancialRouteRouteWithChildren,
  AuthAppAppOrgOrgIdMarketplaceRouteRoute:
    AuthAppAppOrgOrgIdMarketplaceRouteRouteWithChildren,
  AuthAppAppOrgOrgIdSettingsRouteRoute:
    AuthAppAppOrgOrgIdSettingsRouteRouteWithChildren,
  AuthAppAppOrgOrgIdStaffRouteRoute:
    AuthAppAppOrgOrgIdStaffRouteRouteWithChildren,
  AuthAppAppOrgOrgIdAssistantRoute:
    AuthAppAppOrgOrgIdAssistantRouteWithChildren,
  AuthAppAppOrgOrgIdEquipmentRoute:
    AuthAppAppOrgOrgIdEquipmentRouteWithChildren,
  AuthAppAppOrgOrgIdOnboardingRoute: AuthAppAppOrgOrgIdOnboardingRoute,
  AuthAppAppOrgOrgIdUnder_developmentRoute:
    AuthAppAppOrgOrgIdUnder_developmentRoute,
  AuthAppAppOrgOrgIdIndexRoute: AuthAppAppOrgOrgIdIndexRoute,
  AuthAppAppOrgOrgIdLivestockEstablishmentIdRoute:
    AuthAppAppOrgOrgIdLivestockEstablishmentIdRouteWithChildren,
  AuthAppAppOrgOrgIdEstablishmentsIndexRoute:
    AuthAppAppOrgOrgIdEstablishmentsIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionIndexRoute,
  AuthAppAppOrgOrgIdLivestockIndexRoute: AuthAppAppOrgOrgIdLivestockIndexRoute,
  AuthAppAppOrgOrgIdMcpIndexRoute: AuthAppAppOrgOrgIdMcpIndexRoute,
  AuthAppAppOrgOrgIdOfflineCenterIndexRoute:
    AuthAppAppOrgOrgIdOfflineCenterIndexRoute,
  AuthAppAppOrgOrgIdPendingActionsIndexRoute:
    AuthAppAppOrgOrgIdPendingActionsIndexRoute,
  AuthAppAppOrgOrgIdPlanningIndexRoute: AuthAppAppOrgOrgIdPlanningIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute:
    AuthAppAppOrgOrgIdGrassProductionCultivarsNewRoute,
  AuthAppAppOrgOrgIdPlanningTasksCalendarRoute:
    AuthAppAppOrgOrgIdPlanningTasksCalendarRoute,
  AuthAppAppOrgOrgIdPlanningTasksKanbanRoute:
    AuthAppAppOrgOrgIdPlanningTasksKanbanRoute,
  AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionCultivarsIndexRoute,
  AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute:
    AuthAppAppOrgOrgIdPlanningObjectivesIndexRoute,
  AuthAppAppOrgOrgIdPlanningTasksIndexRoute:
    AuthAppAppOrgOrgIdPlanningTasksIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute:
    AuthAppAppOrgOrgIdGrassProductionCultivarsCultivarIdEditRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdIndexRoute,
  AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute:
    AuthAppAppOrgOrgIdPlanningObjectivesObjectiveIdIndexRoute,
  AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute:
    AuthAppAppOrgOrgIdPlanningTasksTaskIdIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksNewRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdSoilReportsImportRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdMapIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdEditRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdIndexRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdMeasurementsNewRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdOperationsNewRoute,
  AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute:
    AuthAppAppOrgOrgIdGrassProductionFarmsFarmIdPaddocksPaddockIdSoilAnalysesAnalysisIdIndexRoute,
}

const AuthAppAppOrgOrgIdRouteWithChildren =
  AuthAppAppOrgOrgIdRoute._addFileChildren(AuthAppAppOrgOrgIdRouteChildren)

interface AuthAppAppRouteChildren {
  AuthAppAppHelpRoute: typeof AuthAppAppHelpRouteWithChildren
  AuthAppAppIndexRoute: typeof AuthAppAppIndexRoute
  AuthAppAppOrgOrgIdRoute: typeof AuthAppAppOrgOrgIdRouteWithChildren
  AuthAppAppOrgRenewPlatformPlanRoute: typeof AuthAppAppOrgRenewPlatformPlanRoute
  AuthAppAppUserSettingsIndexRoute: typeof AuthAppAppUserSettingsIndexRoute
}

const AuthAppAppRouteChildren: AuthAppAppRouteChildren = {
  AuthAppAppHelpRoute: AuthAppAppHelpRouteWithChildren,
  AuthAppAppIndexRoute: AuthAppAppIndexRoute,
  AuthAppAppOrgOrgIdRoute: AuthAppAppOrgOrgIdRouteWithChildren,
  AuthAppAppOrgRenewPlatformPlanRoute: AuthAppAppOrgRenewPlatformPlanRoute,
  AuthAppAppUserSettingsIndexRoute: AuthAppAppUserSettingsIndexRoute,
}

const AuthAppAppRouteWithChildren = AuthAppAppRoute._addFileChildren(
  AuthAppAppRouteChildren,
)

interface AuthRouteChildren {
  AuthAppAppRoute: typeof AuthAppAppRouteWithChildren
  AuthAppSelectOrganizationRoute: typeof AuthAppSelectOrganizationRoute
  AuthStaffInviteTokenRoute: typeof AuthStaffInviteTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppAppRoute: AuthAppAppRouteWithChildren,
  AuthAppSelectOrganizationRoute: AuthAppSelectOrganizationRoute,
  AuthStaffInviteTokenRoute: AuthStaffInviteTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicIndexRoute: typeof PublicIndexRoute
  PublicSignInSplatRoute: typeof PublicSignInSplatRoute
  PublicSignUpSplatRoute: typeof PublicSignUpSplatRoute
  PublicSignInIndexRoute: typeof PublicSignInIndexRoute
  PublicSignUpIndexRoute: typeof PublicSignUpIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,
  PublicSignInSplatRoute: PublicSignInSplatRoute,
  PublicSignUpSplatRoute: PublicSignUpSplatRoute,
  PublicSignInIndexRoute: PublicSignInIndexRoute,
  PublicSignUpIndexRoute: PublicSignUpIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
